//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PAYROLL_API_BASE_URL = new InjectionToken<string>('PAYROLL_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class PayrollFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYROLL_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param payRateType (optional) 
     * @return Success
     */
    downloadPayRateCsvTemplate(payRateType?: PayRateType | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/downloadsample?";
        if (payRateType === null)
            throw new Error("The parameter 'payRateType' cannot be null.");
        else if (payRateType !== undefined)
            url_ += "payRateType=" + encodeURIComponent("" + payRateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPayRateCsvTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPayRateCsvTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadPayRateCsvTemplate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertEmployerCostRate(body?: EmployerCostRateDto | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/employercostrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEmployerCostRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEmployerCostRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertEmployerCostRate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployerCostRate(body?: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employercostrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmployerCostRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmployerCostRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEmployerCostRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEmployerCostRatesByFilter(body?: FilterRequest | undefined): Observable<EmployerCostRateEntityGridResponseBase> {
        let url_ = this.baseUrl + "/api/employercostrates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerCostRatesByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerCostRatesByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerCostRateEntityGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerCostRateEntityGridResponseBase>;
        }));
    }

    protected processGetEmployerCostRatesByFilter(response: HttpResponseBase): Observable<EmployerCostRateEntityGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerCostRateEntityGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployerCostRateById(id: number): Observable<EmployerCostRateEntity> {
        let url_ = this.baseUrl + "/api/employercostrates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerCostRateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerCostRateById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerCostRateEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerCostRateEntity>;
        }));
    }

    protected processGetEmployerCostRateById(response: HttpResponseBase): Observable<EmployerCostRateEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerCostRateEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllExclusionCriteria(body?: ExclusionCriteriaFilterRequest | undefined): Observable<ExclusionCriterionEntryGridResponseBase> {
        let url_ = this.baseUrl + "/api/exclusioncriteria/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExclusionCriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExclusionCriteria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExclusionCriterionEntryGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExclusionCriterionEntryGridResponseBase>;
        }));
    }

    protected processGetAllExclusionCriteria(response: HttpResponseBase): Observable<ExclusionCriterionEntryGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExclusionCriterionEntryGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHolidayPayDates(body?: HolidayPayDateDto[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/holidaypaydate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHolidayPayDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHolidayPayDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processCreateHolidayPayDates(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHolidayPayDates(body?: HolidayPayDateDto[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/holidaypaydate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHolidayPayDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHolidayPayDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateHolidayPayDates(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getHolidayPayDates(ecn: string): Observable<HolidayPayDateDto[]> {
        let url_ = this.baseUrl + "/api/holidaypaydate/{ecn}";
        if (ecn === undefined || ecn === null)
            throw new Error("The parameter 'ecn' must be defined.");
        url_ = url_.replace("{ecn}", encodeURIComponent("" + ecn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHolidayPayDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayPayDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayPayDateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayPayDateDto[]>;
        }));
    }

    protected processGetHolidayPayDates(response: HttpResponseBase): Observable<HolidayPayDateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HolidayPayDateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantId (optional) 
     * @param caregiverEmployerMappingId (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param filterType (optional) 
     * @return Success
     */
    getParticipantCaregiverEmployerPayRates(participantId?: number | undefined, caregiverEmployerMappingId?: number | undefined, sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<ParticipantCaregiverEmployerPayRateDataGridResponseBase> {
        let url_ = this.baseUrl + "/api/participant-caregiver-employer-payrates?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        if (caregiverEmployerMappingId === null)
            throw new Error("The parameter 'caregiverEmployerMappingId' cannot be null.");
        else if (caregiverEmployerMappingId !== undefined)
            url_ += "caregiverEmployerMappingId=" + encodeURIComponent("" + caregiverEmployerMappingId) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantCaregiverEmployerPayRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantCaregiverEmployerPayRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantCaregiverEmployerPayRateDataGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantCaregiverEmployerPayRateDataGridResponseBase>;
        }));
    }

    protected processGetParticipantCaregiverEmployerPayRates(response: HttpResponseBase): Observable<ParticipantCaregiverEmployerPayRateDataGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantCaregiverEmployerPayRateDataGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertParticipantCaregiverEmployerPayRate(body?: ParticipantCaregiverEmployerPayRateData | undefined): Observable<IActionResultTask> {
        let url_ = this.baseUrl + "/api/participant-caregiver-employer-payrates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertParticipantCaregiverEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertParticipantCaregiverEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActionResultTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActionResultTask>;
        }));
    }

    protected processUpsertParticipantCaregiverEmployerPayRate(response: HttpResponseBase): Observable<IActionResultTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IActionResultTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param participantId (optional) 
     * @param caregiverEmployerMappingId (optional) 
     * @param body (optional) 
     * @return Success
     */
    deleteParticipantCaregiverEmployerPayRate(participantId?: number | undefined, caregiverEmployerMappingId?: number | undefined, body?: IdsRequest | undefined): Observable<IActionResultTask> {
        let url_ = this.baseUrl + "/api/participant-caregiver-employer-payrates?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        if (caregiverEmployerMappingId === null)
            throw new Error("The parameter 'caregiverEmployerMappingId' cannot be null.");
        else if (caregiverEmployerMappingId !== undefined)
            url_ += "caregiverEmployerMappingId=" + encodeURIComponent("" + caregiverEmployerMappingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParticipantCaregiverEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParticipantCaregiverEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IActionResultTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IActionResultTask>;
        }));
    }

    protected processDeleteParticipantCaregiverEmployerPayRate(response: HttpResponseBase): Observable<IActionResultTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IActionResultTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParticipantCaregiverEmployerPayRate(id: number): Observable<ParticipantCaregiverEmployerPayRateData> {
        let url_ = this.baseUrl + "/api/participant-caregiver-employer-payrates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParticipantCaregiverEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParticipantCaregiverEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipantCaregiverEmployerPayRateData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipantCaregiverEmployerPayRateData>;
        }));
    }

    protected processGetParticipantCaregiverEmployerPayRate(response: HttpResponseBase): Observable<ParticipantCaregiverEmployerPayRateData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantCaregiverEmployerPayRateData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayRate(body?: PayRateRequest | undefined): Observable<PayRateResponse> {
        let url_ = this.baseUrl + "/api/payrate/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateResponse>;
        }));
    }

    protected processGetPayRate(response: HttpResponseBase): Observable<PayRateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayRateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayRateGetCchRateHistory(body?: PayRateHistoryRequest | undefined): Observable<CchRateHistoryHolder[]> {
        let url_ = this.baseUrl + "/api/payrate/history/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRateGetCchRateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRateGetCchRateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CchRateHistoryHolder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CchRateHistoryHolder[]>;
        }));
    }

    protected processGetPayRateGetCchRateHistory(response: HttpResponseBase): Observable<CchRateHistoryHolder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CchRateHistoryHolder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param payRateType (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadPayRate(payRateType?: PayRateType | undefined, file?: FileParameter | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payrate/upload?";
        if (payRateType === null)
            throw new Error("The parameter 'payRateType' cannot be null.");
        else if (payRateType !== undefined)
            url_ += "payRateType=" + encodeURIComponent("" + payRateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUploadPayRate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param filterType (optional) 
     * @return Success
     */
    getCareerHourPayRates(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<CareerHourPayRateDomainModel[]> {
        let url_ = this.baseUrl + "/api/payrates/careerhour?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCareerHourPayRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCareerHourPayRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourPayRateDomainModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourPayRateDomainModel[]>;
        }));
    }

    protected processGetCareerHourPayRates(response: HttpResponseBase): Observable<CareerHourPayRateDomainModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourPayRateDomainModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCareerHourPayRate(body?: CareerHourPayRateData[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/payrates/careerhour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCareerHourPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCareerHourPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertCareerHourPayRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertEmployerPayRate(body?: EmployerPayRateData[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/payrates/employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertEmployerPayRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEmployerPayRate(body?: EmployerPayRateData[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/payrates/employer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEmployerPayRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmployerPayRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEmployerPayRate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param filterType (optional) 
     * @return Success
     */
    getEmployerPayRates(employerId: number, sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<EmployerPayRateDataGridResponseBase> {
        let url_ = this.baseUrl + "/api/payrates/employer/{employerId}?";
        if (employerId === undefined || employerId === null)
            throw new Error("The parameter 'employerId' must be defined.");
        url_ = url_.replace("{employerId}", encodeURIComponent("" + employerId));
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployerPayRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployerPayRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployerPayRateDataGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployerPayRateDataGridResponseBase>;
        }));
    }

    protected processGetEmployerPayRates(response: HttpResponseBase): Observable<EmployerPayRateDataGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployerPayRateDataGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayRates(body?: PayRateRequest[] | undefined): Observable<PayRateResponseBulk[]> {
        let url_ = this.baseUrl + "/api/payrates/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayRateResponseBulk[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayRateResponseBulk[]>;
        }));
    }

    protected processGetPayRates(response: HttpResponseBase): Observable<PayRateResponseBulk[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayRateResponseBulk.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllPreviewRecordsWithDefaultExclusions(body?: PreviewPayrollBatchRequest | undefined): Observable<ExcludedRecordsResponse[]> {
        let url_ = this.baseUrl + "/api/payroll/batch/defaultexclusions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPreviewRecordsWithDefaultExclusions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPreviewRecordsWithDefaultExclusions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcludedRecordsResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcludedRecordsResponse[]>;
        }));
    }

    protected processGetAllPreviewRecordsWithDefaultExclusions(response: HttpResponseBase): Observable<ExcludedRecordsResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExcludedRecordsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enqueuePayrollBatch(body?: CreatePayrollBatchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/enqueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueuePayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueuePayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processEnqueuePayrollBatch(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enqueueExportPayrollBatchExcludedRecords(body?: ExcludedRecords | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/excludedrecords/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueExportPayrollBatchExcludedRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueExportPayrollBatchExcludedRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processEnqueueExportPayrollBatchExcludedRecords(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExclusionReasons(): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/exclusionreasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExclusionReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExclusionReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processGetExclusionReasons(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enqueueExportPayrollBatchPreview(body?: PreviewPayrollBatchRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueExportPayrollBatchPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueExportPayrollBatchPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processEnqueueExportPayrollBatchPreview(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPayrollRuns(): Observable<PayrollRunGridResponseBase> {
        let url_ = this.baseUrl + "/api/payroll/batch/payrollruns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollRuns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollRuns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRunGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRunGridResponseBase>;
        }));
    }

    protected processGetPayrollRuns(response: HttpResponseBase): Observable<PayrollRunGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollRunGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getPayrollSystems(request?: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/payroll/batch/payrollsystems?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollSystems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollSystems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetPayrollSystems(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayrollRecordsForEPR(body?: EPRRecordRequest | undefined): Observable<EPRRecordsResponseGridResponseBase> {
        let url_ = this.baseUrl + "/api/payroll/batch/recordsForEPR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollRecordsForEPR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollRecordsForEPR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EPRRecordsResponseGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EPRRecordsResponseGridResponseBase>;
        }));
    }

    protected processGetPayrollRecordsForEPR(response: HttpResponseBase): Observable<EPRRecordsResponseGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EPRRecordsResponseGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBatchAggregatesForReview(body?: BatchReviewRequest | undefined): Observable<PayrollAggregateDetailsGridResponseBase> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/aggregates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchAggregatesForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchAggregatesForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollAggregateDetailsGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollAggregateDetailsGridResponseBase>;
        }));
    }

    protected processGetBatchAggregatesForReview(response: HttpResponseBase): Observable<PayrollAggregateDetailsGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollAggregateDetailsGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBatchDetailForReview(body?: BatchReviewRequest | undefined): Observable<BatchReviewDetails> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchDetailForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchDetailForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchReviewDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchReviewDetails>;
        }));
    }

    protected processGetBatchDetailForReview(response: HttpResponseBase): Observable<BatchReviewDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchReviewDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enqueueBatchReview(body?: BatchReviewEnqueueRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/enqueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueBatchReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueBatchReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processEnqueueBatchReview(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBatchExcludedRecords(payrollRunId: string, body?: ExcludedRecordsInputRequest | undefined): Observable<ExcludedBatchRecordsGridResponseBase> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/excludedrecords/{payrollRunId}";
        if (payrollRunId === undefined || payrollRunId === null)
            throw new Error("The parameter 'payrollRunId' must be defined.");
        url_ = url_.replace("{payrollRunId}", encodeURIComponent("" + payrollRunId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchExcludedRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchExcludedRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExcludedBatchRecordsGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExcludedBatchRecordsGridResponseBase>;
        }));
    }

    protected processGetBatchExcludedRecords(response: HttpResponseBase): Observable<ExcludedBatchRecordsGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcludedBatchRecordsGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enqueueExportPayrollBatchReviewDetails(body?: BatchReviewRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueExportPayrollBatchReviewDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueExportPayrollBatchReviewDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processEnqueueExportPayrollBatchReviewDetails(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBatchHistoryForReview(body?: PostRequestBase | undefined): Observable<PayrollRunStatusStatusHistoryGridResponseBase> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchHistoryForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchHistoryForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRunStatusStatusHistoryGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRunStatusStatusHistoryGridResponseBase>;
        }));
    }

    protected processGetBatchHistoryForReview(response: HttpResponseBase): Observable<PayrollRunStatusStatusHistoryGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollRunStatusStatusHistoryGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBatchDetailForReview(body?: SaveReviewBatchCommand | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBatchDetailForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBatchDetailForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processSaveBatchDetailForReview(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchBatchForReview(body?: BatchReviewSearchRequest | undefined): Observable<BatchReviewDataGridResponseBase> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBatchForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBatchForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchReviewDataGridResponseBase>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchReviewDataGridResponseBase>;
        }));
    }

    protected processSearchBatchForReview(response: HttpResponseBase): Observable<BatchReviewDataGridResponseBase> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchReviewDataGridResponseBase.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getBatchReviewTotals(payrollSystem: string, payrollRunId: string): Observable<BatchReviewTotals[]> {
        let url_ = this.baseUrl + "/api/payroll/batch/review/totals/{payrollSystem}/{payrollRunId}";
        if (payrollSystem === undefined || payrollSystem === null)
            throw new Error("The parameter 'payrollSystem' must be defined.");
        url_ = url_.replace("{payrollSystem}", encodeURIComponent("" + payrollSystem));
        if (payrollRunId === undefined || payrollRunId === null)
            throw new Error("The parameter 'payrollRunId' must be defined.");
        url_ = url_.replace("{payrollRunId}", encodeURIComponent("" + payrollRunId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchReviewTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchReviewTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchReviewTotals[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchReviewTotals[]>;
        }));
    }

    protected processGetBatchReviewTotals(response: HttpResponseBase): Observable<BatchReviewTotals[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchReviewTotals.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewPayrollBatch(body?: PreviewPayrollBatchRequest | undefined): Observable<PayrollBatchPreviewResponse> {
        let url_ = this.baseUrl + "/api/payroll/batch/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreviewPayrollBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreviewPayrollBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollBatchPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollBatchPreviewResponse>;
        }));
    }

    protected processPreviewPayrollBatch(response: HttpResponseBase): Observable<PayrollBatchPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollBatchPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertEPRRecords(body?: EPRUpsertRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/batch/upsertEPRRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEPRRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEPRRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertEPRRecords(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPayrollConfigurations(): Observable<PayrollConfigDetails[]> {
        let url_ = this.baseUrl + "/api/payroll/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayrollConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayrollConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollConfigDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollConfigDetails[]>;
        }));
    }

    protected processGetAllPayrollConfigurations(response: HttpResponseBase): Observable<PayrollConfigDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayrollConfigDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertPayrollConfiguration(body?: UpsertPayrollConfigurationRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertPayrollConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertPayrollConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpsertPayrollConfiguration(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteServeEarnMappings(body?: DeleteServeEarnMappingRequest[] | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteServeEarnMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteServeEarnMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteServeEarnMappings(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    getAllEarnCodes(): Observable<PayrollConfigEarn[]> {
        let url_ = this.baseUrl + "/api/payroll/config/earn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEarnCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEarnCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollConfigEarn[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollConfigEarn[]>;
        }));
    }

    protected processGetAllEarnCodes(response: HttpResponseBase): Observable<PayrollConfigEarn[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayrollConfigEarn.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    getAllServCodes(): Observable<PayrollConfigServe[]> {
        let url_ = this.baseUrl + "/api/payroll/config/serve";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollConfigServe[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollConfigServe[]>;
        }));
    }

    protected processGetAllServCodes(response: HttpResponseBase): Observable<PayrollConfigServe[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayrollConfigServe.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayrollDetailsByTcnId(body?: PayrollDetailsRequest | undefined): Observable<PayrollRecordDetails[]> {
        let url_ = this.baseUrl + "/api/payroll/details/tcnIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollDetailsByTcnId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollDetailsByTcnId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRecordDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRecordDetails[]>;
        }));
    }

    protected processGetPayrollDetailsByTcnId(response: HttpResponseBase): Observable<PayrollRecordDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayrollRecordDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFLSAPeriods(minDate: Date, maxDate: Date): Observable<FLSAPeriod[]> {
        let url_ = this.baseUrl + "/api/payroll/flsaperiod/{minDate}/{maxDate}";
        if (minDate === undefined || minDate === null)
            throw new Error("The parameter 'minDate' must be defined.");
        url_ = url_.replace("{minDate}", encodeURIComponent(minDate ? "" + minDate.toISOString() : "null"));
        if (maxDate === undefined || maxDate === null)
            throw new Error("The parameter 'maxDate' must be defined.");
        url_ = url_.replace("{maxDate}", encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFLSAPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFLSAPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FLSAPeriod[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FLSAPeriod[]>;
        }));
    }

    protected processGetFLSAPeriods(response: HttpResponseBase): Observable<FLSAPeriod[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FLSAPeriod.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentPayPeriod(): Observable<PayPeriod> {
        let url_ = this.baseUrl + "/api/payroll/flsaperiod/getcurrentpayperiod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPayPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPayPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayPeriod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayPeriod>;
        }));
    }

    protected processGetCurrentPayPeriod(response: HttpResponseBase): Observable<PayPeriod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPeriod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteLockedTcns(body?: string | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/lockedtcns/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLockedTcns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLockedTcns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteLockedTcns(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayrollTcnsLockedStatus(body?: GetLockedTcnsStatusRequest | undefined): Observable<GetLockedTcnsStatusResponse[]> {
        let url_ = this.baseUrl + "/api/payroll/lockedtcns/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollTcnsLockedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollTcnsLockedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLockedTcnsStatusResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLockedTcnsStatusResponse[]>;
        }));
    }

    protected processGetPayrollTcnsLockedStatus(response: HttpResponseBase): Observable<GetLockedTcnsStatusResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetLockedTcnsStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveLockedTcns(body?: AddLockedTcnsRequest | undefined): Observable<PayrollLockTcnStatus> {
        let url_ = this.baseUrl + "/api/payroll/lockedtcns/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveLockedTcns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveLockedTcns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollLockTcnStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollLockTcnStatus>;
        }));
    }

    protected processSaveLockedTcns(response: HttpResponseBase): Observable<PayrollLockTcnStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollLockTcnStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteLockedTcnsByIds(body?: DeleteRequestLockedTcns | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/lockedtcnsbyids/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLockedTcnsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLockedTcnsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processDeleteLockedTcnsByIds(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    updatePayrolBatchStatus(body?: UpdateTcnStatusRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/markaspaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePayrolBatchStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePayrolBatchStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdatePayrolBatchStatus(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paidPayrollUpdate(body?: UpdateTcnStatusRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/paidpayrollupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaidPayrollUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaidPayrollUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processPaidPayrollUpdate(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPcnStatusFromTcn(body?: GetTcnsForPcnStatusRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/payroll/pcnstatusfromtcn/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPcnStatusFromTcn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPcnStatusFromTcn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetPcnStatusFromTcn(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertRunStatus(body?: PayrollRunStatusRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/run-status/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertRunStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertRunStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processInsertRunStatus(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTransactionLogDetails(body?: PayrollTransactionLogRequest | undefined): Observable<PayrollTransactionLogSummary> {
        let url_ = this.baseUrl + "/api/payroll/transactionLog/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionLogDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionLogDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollTransactionLogSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollTransactionLogSummary>;
        }));
    }

    protected processGetTransactionLogDetails(response: HttpResponseBase): Observable<PayrollTransactionLogSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollTransactionLogSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enqueueExportPayrollTransaction(body?: PayrollTransactionLogRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/transactionLog/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueExportPayrollTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueExportPayrollTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processEnqueueExportPayrollTransaction(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTransactionLogHistory(body?: TransactionLogHistoryRequest | undefined): Observable<TransactionLogHistory[]> {
        let url_ = this.baseUrl + "/api/payroll/transactionLog/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionLogHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionLogHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionLogHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionLogHistory[]>;
        }));
    }

    protected processGetTransactionLogHistory(response: HttpResponseBase): Observable<TransactionLogHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionLogHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransactionLogMassRecordExclusionStatus(body?: PayrollMassRecordUpdateExclusionRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/transactionLog/massrecordexclusionupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransactionLogMassRecordExclusionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransactionLogMassRecordExclusionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateTransactionLogMassRecordExclusionStatus(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTransactionLogRecordExclusionStatus(body?: PayrollRecordUpdateExclusionRequest | undefined): Observable<ResponseModel> {
        let url_ = this.baseUrl + "/api/payroll/transactionLog/recordexclusionupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransactionLogRecordExclusionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransactionLogRecordExclusionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseModel>;
        }));
    }

    protected processUpdateTransactionLogRecordExclusionStatus(response: HttpResponseBase): Observable<ResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayrollRulesData(body?: PayrollRulesDataRequest | undefined): Observable<PayrollRulesDataResponse> {
        let url_ = this.baseUrl + "/api/payrollrulesdata/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayrollRulesData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollRulesData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRulesDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRulesDataResponse>;
        }));
    }

    protected processGetPayrollRulesData(response: HttpResponseBase): Observable<PayrollRulesDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayrollRulesDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCareerHourRatePeriod(body?: CareerHourRatePeriodDto[] | undefined): Observable<CareerHourRatePeriodDto[]> {
        let url_ = this.baseUrl + "/api/period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCareerHourRatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCareerHourRatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRatePeriodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRatePeriodDto[]>;
        }));
    }

    protected processUpsertCareerHourRatePeriod(response: HttpResponseBase): Observable<CareerHourRatePeriodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRatePeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateByPeriodId(careerHourRatePeriodId: number): Observable<CareerHourRateDto[]> {
        let url_ = this.baseUrl + "/api/period/{careerHourRatePeriodId}/rates";
        if (careerHourRatePeriodId === undefined || careerHourRatePeriodId === null)
            throw new Error("The parameter 'careerHourRatePeriodId' must be defined.");
        url_ = url_.replace("{careerHourRatePeriodId}", encodeURIComponent("" + careerHourRatePeriodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateByPeriodId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateByPeriodId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateDto[]>;
        }));
    }

    protected processGetAllCareerHourRateByPeriodId(response: HttpResponseBase): Observable<CareerHourRateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkOverlapCareerHourRatePeriod(body?: CareerHourRatePeriodDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/period/checkoverlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOverlapCareerHourRatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOverlapCareerHourRatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckOverlapCareerHourRatePeriod(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateModifierByCareerHourRateId(careerHourRateId: number): Observable<CareerHourRateModifierDto[]> {
        let url_ = this.baseUrl + "/api/period/rate/{careerHourRateId}/modifiers";
        if (careerHourRateId === undefined || careerHourRateId === null)
            throw new Error("The parameter 'careerHourRateId' must be defined.");
        url_ = url_.replace("{careerHourRateId}", encodeURIComponent("" + careerHourRateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateModifierByCareerHourRateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateModifierByCareerHourRateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierDto[]>;
        }));
    }

    protected processGetAllCareerHourRateModifierByCareerHourRateId(response: HttpResponseBase): Observable<CareerHourRateModifierDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateModifierQualificationByCareerHourRateModifierId(careerHourRateModifierId: number): Observable<CareerHourRateModifierQualificationDto[]> {
        let url_ = this.baseUrl + "/api/period/rate/modifier/{careerHourRateModifierId}/qualifications";
        if (careerHourRateModifierId === undefined || careerHourRateModifierId === null)
            throw new Error("The parameter 'careerHourRateModifierId' must be defined.");
        url_ = url_.replace("{careerHourRateModifierId}", encodeURIComponent("" + careerHourRateModifierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateModifierQualificationByCareerHourRateModifierId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateModifierQualificationByCareerHourRateModifierId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierQualificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierQualificationDto[]>;
        }));
    }

    protected processGetAllCareerHourRateModifierQualificationByCareerHourRateModifierId(response: HttpResponseBase): Observable<CareerHourRateModifierQualificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierQualificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCareerHourRateModifierQualificationByCareerHourRateModifierId(body?: CareerHourRateModifierQualificationDto[] | undefined): Observable<CareerHourRateModifierQualificationDto[]> {
        let url_ = this.baseUrl + "/api/period/rate/modifier/qualifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCareerHourRateModifierQualificationByCareerHourRateModifierId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCareerHourRateModifierQualificationByCareerHourRateModifierId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierQualificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierQualificationDto[]>;
        }));
    }

    protected processUpsertCareerHourRateModifierQualificationByCareerHourRateModifierId(response: HttpResponseBase): Observable<CareerHourRateModifierQualificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierQualificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCareerHourRateModifierByCareerHourRateId(body?: CareerHourRateModifierDto[] | undefined): Observable<CareerHourRateModifierDto[]> {
        let url_ = this.baseUrl + "/api/period/rate/modifiers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCareerHourRateModifierByCareerHourRateId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCareerHourRateModifierByCareerHourRateId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateModifierDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateModifierDto[]>;
        }));
    }

    protected processUpsertCareerHourRateModifierByCareerHourRateId(response: HttpResponseBase): Observable<CareerHourRateModifierDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateModifierDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upsertCareerHourRateByPeriodId(body?: CareerHourRateDto[] | undefined): Observable<CareerHourRateDto[]> {
        let url_ = this.baseUrl + "/api/period/rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertCareerHourRateByPeriodId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertCareerHourRateByPeriodId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateDto[]>;
        }));
    }

    protected processUpsertCareerHourRateByPeriodId(response: HttpResponseBase): Observable<CareerHourRateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param filterType (optional) 
     * @return Success
     */
    getAllCareerHourRatePeriods(sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, pageSize?: number | undefined, pageNumber?: number | undefined, filterType?: string | undefined): Observable<CareerHourRatePeriodDto[]> {
        let url_ = this.baseUrl + "/api/periods?";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRatePeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRatePeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRatePeriodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRatePeriodDto[]>;
        }));
    }

    protected processGetAllCareerHourRatePeriods(response: HttpResponseBase): Observable<CareerHourRatePeriodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRatePeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCareerHourRateInfo(): Observable<CareerHourRateInfo[]> {
        let url_ = this.baseUrl + "/api/rateinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCareerHourRateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCareerHourRateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CareerHourRateInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CareerHourRateInfo[]>;
        }));
    }

    protected processGetAllCareerHourRateInfo(response: HttpResponseBase): Observable<CareerHourRateInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareerHourRateInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortDirection (optional) 
     * @param filterColumn (optional) 
     * @param filterValue (optional) 
     * @param search (optional) 
     * @return Success
     */
    getServiceCodes(pageNumber?: number | undefined, pageSize?: number | undefined, sortColumn?: string | undefined, sortDirection?: string | undefined, filterColumn?: string | undefined, filterValue?: string | undefined, search?: string | undefined): Observable<ServiceCode[]> {
        let url_ = this.baseUrl + "/payroll/serviceCode?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn === null)
            throw new Error("The parameter 'sortColumn' cannot be null.");
        else if (sortColumn !== undefined)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterColumn === null)
            throw new Error("The parameter 'filterColumn' cannot be null.");
        else if (filterColumn !== undefined)
            url_ += "FilterColumn=" + encodeURIComponent("" + filterColumn) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "FilterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCode[]>;
        }));
    }

    protected processGetServiceCodes(response: HttpResponseBase): Observable<ServiceCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AddLockedTcnsRequest implements IAddLockedTcnsRequest {
    mode?: AdjustmentMode;
    blobFileName?: string | undefined;
    batchId?: string | undefined;
    tcn?: string[] | undefined;
    lockedBy?: TcnLockedBy;
    userEmailId?: string | undefined;
    bulkIngestion?: boolean;

    constructor(data?: IAddLockedTcnsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.blobFileName = _data["blobFileName"];
            this.batchId = _data["batchId"];
            if (Array.isArray(_data["tcn"])) {
                this.tcn = [] as any;
                for (let item of _data["tcn"])
                    this.tcn!.push(item);
            }
            this.lockedBy = _data["lockedBy"];
            this.userEmailId = _data["userEmailId"];
            this.bulkIngestion = _data["bulkIngestion"];
        }
    }

    static fromJS(data: any): AddLockedTcnsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddLockedTcnsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["blobFileName"] = this.blobFileName;
        data["batchId"] = this.batchId;
        if (Array.isArray(this.tcn)) {
            data["tcn"] = [];
            for (let item of this.tcn)
                data["tcn"].push(item);
        }
        data["lockedBy"] = this.lockedBy;
        data["userEmailId"] = this.userEmailId;
        data["bulkIngestion"] = this.bulkIngestion;
        return data;
    }
}

export interface IAddLockedTcnsRequest {
    mode?: AdjustmentMode;
    blobFileName?: string | undefined;
    batchId?: string | undefined;
    tcn?: string[] | undefined;
    lockedBy?: TcnLockedBy;
    userEmailId?: string | undefined;
    bulkIngestion?: boolean;
}

export enum AdjustmentMode {
    Normal = "Normal",
    Bulk = "Bulk",
}

export class AggregateException implements IAggregateException {
    targetSite?: MethodBase;
    readonly data?: { [key: string]: any; } | undefined;
    innerException?: Exception;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult?: number;
    readonly stackTrace?: string | undefined;
    readonly innerExceptions?: Exception[] | undefined;
    readonly message?: string | undefined;

    constructor(data?: IAggregateException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetSite = _data["targetSite"] ? MethodBase.fromJS(_data["targetSite"]) : <any>undefined;
            if (_data["data"]) {
                (<any>this).data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>(<any>this).data)![key] = _data["data"][key];
                }
            }
            this.innerException = _data["innerException"] ? Exception.fromJS(_data["innerException"]) : <any>undefined;
            this.helpLink = _data["helpLink"];
            this.source = _data["source"];
            this.hResult = _data["hResult"];
            (<any>this).stackTrace = _data["stackTrace"];
            if (Array.isArray(_data["innerExceptions"])) {
                (<any>this).innerExceptions = [] as any;
                for (let item of _data["innerExceptions"])
                    (<any>this).innerExceptions!.push(Exception.fromJS(item));
            }
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): AggregateException {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSite"] = this.targetSite ? this.targetSite.toJSON() : <any>undefined;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["innerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["helpLink"] = this.helpLink;
        data["source"] = this.source;
        data["hResult"] = this.hResult;
        data["stackTrace"] = this.stackTrace;
        if (Array.isArray(this.innerExceptions)) {
            data["innerExceptions"] = [];
            for (let item of this.innerExceptions)
                data["innerExceptions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["message"] = this.message;
        return data;
    }
}

export interface IAggregateException {
    targetSite?: MethodBase;
    data?: { [key: string]: any; } | undefined;
    innerException?: Exception;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult?: number;
    stackTrace?: string | undefined;
    innerExceptions?: Exception[] | undefined;
    message?: string | undefined;
}

export class Assembly implements IAssembly {
    readonly definedTypes?: TypeInfo[] | undefined;
    readonly exportedTypes?: Type[] | undefined;
    readonly codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    readonly fullName?: string | undefined;
    readonly imageRuntimeVersion?: string | undefined;
    readonly isDynamic?: boolean;
    readonly location?: string | undefined;
    readonly reflectionOnly?: boolean;
    readonly isCollectible?: boolean;
    readonly isFullyTrusted?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    readonly modules?: Module[] | undefined;
    readonly globalAssemblyCache?: boolean;
    readonly hostContext?: number;
    securityRuleSet?: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes?: TypeInfo[] | undefined;
    exportedTypes?: Type[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic?: boolean;
    location?: string | undefined;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    modules?: Module[] | undefined;
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export enum BatchReviewAction {
    Submit = "Submit",
    Approve = "Approve",
    Delete = "Delete",
    Reject = "Reject",
    Export = "Export",
}

export class BatchReviewData implements IBatchReviewData {
    payrollRunId?: string | undefined;
    status?: PayrollRunStatus;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    readonly statusText?: string | undefined;
    isProcessing?: boolean;
    paidDate?: Date | undefined;
    description?: string | undefined;
    estimatedPayDate?: Date;

    constructor(data?: IBatchReviewData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollRunId = _data["payrollRunId"];
            this.status = _data["status"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            (<any>this).statusText = _data["statusText"];
            this.isProcessing = _data["isProcessing"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.estimatedPayDate = _data["estimatedPayDate"] ? new Date(_data["estimatedPayDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchReviewData {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollRunId"] = this.payrollRunId;
        data["status"] = this.status;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["statusText"] = this.statusText;
        data["isProcessing"] = this.isProcessing;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["estimatedPayDate"] = this.estimatedPayDate ? this.estimatedPayDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatchReviewData {
    payrollRunId?: string | undefined;
    status?: PayrollRunStatus;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    statusText?: string | undefined;
    isProcessing?: boolean;
    paidDate?: Date | undefined;
    description?: string | undefined;
    estimatedPayDate?: Date;
}

export class BatchReviewDataGridResponseBase implements IBatchReviewDataGridResponseBase {
    items?: BatchReviewData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BatchReviewData;

    constructor(data?: IBatchReviewDataGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BatchReviewData.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? BatchReviewData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchReviewDataGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewDataGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchReviewDataGridResponseBase {
    items?: BatchReviewData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: BatchReviewData;
}

export class BatchReviewDetails implements IBatchReviewDetails {
    payrollRunId?: string | undefined;
    status?: PayrollRunStatus;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    readonly statusText?: string | undefined;
    isProcessing?: boolean;
    paidDate?: Date | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    payors?: string[] | undefined;
    caregivers?: string[] | undefined;
    caregiverCount?: number;
    aggregateCount?: number;
    regAggregateCount?: number;
    holidayAggregateCount?: number;
    overtimeAggregateCount?: number;
    totalPay?: number;
    totalRegPay?: number;
    totalHolidayPay?: number;
    totalOvertimePay?: number;
    mileageCount?: number;
    exemptCount?: number;
    mileagePay?: number;
    exemptPay?: number;
    totalUnits?: number;
    estimatedPayDate?: Date;

    constructor(data?: IBatchReviewDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollRunId = _data["payrollRunId"];
            this.status = _data["status"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            (<any>this).statusText = _data["statusText"];
            this.isProcessing = _data["isProcessing"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(item);
            }
            if (Array.isArray(_data["caregivers"])) {
                this.caregivers = [] as any;
                for (let item of _data["caregivers"])
                    this.caregivers!.push(item);
            }
            this.caregiverCount = _data["caregiverCount"];
            this.aggregateCount = _data["aggregateCount"];
            this.regAggregateCount = _data["regAggregateCount"];
            this.holidayAggregateCount = _data["holidayAggregateCount"];
            this.overtimeAggregateCount = _data["overtimeAggregateCount"];
            this.totalPay = _data["totalPay"];
            this.totalRegPay = _data["totalRegPay"];
            this.totalHolidayPay = _data["totalHolidayPay"];
            this.totalOvertimePay = _data["totalOvertimePay"];
            this.mileageCount = _data["mileageCount"];
            this.exemptCount = _data["exemptCount"];
            this.mileagePay = _data["mileagePay"];
            this.exemptPay = _data["exemptPay"];
            this.totalUnits = _data["totalUnits"];
            this.estimatedPayDate = _data["estimatedPayDate"] ? new Date(_data["estimatedPayDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchReviewDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollRunId"] = this.payrollRunId;
        data["status"] = this.status;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["statusText"] = this.statusText;
        data["isProcessing"] = this.isProcessing;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item);
        }
        if (Array.isArray(this.caregivers)) {
            data["caregivers"] = [];
            for (let item of this.caregivers)
                data["caregivers"].push(item);
        }
        data["caregiverCount"] = this.caregiverCount;
        data["aggregateCount"] = this.aggregateCount;
        data["regAggregateCount"] = this.regAggregateCount;
        data["holidayAggregateCount"] = this.holidayAggregateCount;
        data["overtimeAggregateCount"] = this.overtimeAggregateCount;
        data["totalPay"] = this.totalPay;
        data["totalRegPay"] = this.totalRegPay;
        data["totalHolidayPay"] = this.totalHolidayPay;
        data["totalOvertimePay"] = this.totalOvertimePay;
        data["mileageCount"] = this.mileageCount;
        data["exemptCount"] = this.exemptCount;
        data["mileagePay"] = this.mileagePay;
        data["exemptPay"] = this.exemptPay;
        data["totalUnits"] = this.totalUnits;
        data["estimatedPayDate"] = this.estimatedPayDate ? this.estimatedPayDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatchReviewDetails {
    payrollRunId?: string | undefined;
    status?: PayrollRunStatus;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    statusText?: string | undefined;
    isProcessing?: boolean;
    paidDate?: Date | undefined;
    description?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    payors?: string[] | undefined;
    caregivers?: string[] | undefined;
    caregiverCount?: number;
    aggregateCount?: number;
    regAggregateCount?: number;
    holidayAggregateCount?: number;
    overtimeAggregateCount?: number;
    totalPay?: number;
    totalRegPay?: number;
    totalHolidayPay?: number;
    totalOvertimePay?: number;
    mileageCount?: number;
    exemptCount?: number;
    mileagePay?: number;
    exemptPay?: number;
    totalUnits?: number;
    estimatedPayDate?: Date;
}

export class BatchReviewEnqueueRequest implements IBatchReviewEnqueueRequest {
    action?: BatchReviewAction;
    payrollRunIds?: string[] | undefined;
    payrollJobId?: string | undefined;
    payrollSystem?: string | undefined;

    constructor(data?: IBatchReviewEnqueueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            if (Array.isArray(_data["payrollRunIds"])) {
                this.payrollRunIds = [] as any;
                for (let item of _data["payrollRunIds"])
                    this.payrollRunIds!.push(item);
            }
            this.payrollJobId = _data["payrollJobId"];
            this.payrollSystem = _data["payrollSystem"];
        }
    }

    static fromJS(data: any): BatchReviewEnqueueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewEnqueueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        if (Array.isArray(this.payrollRunIds)) {
            data["payrollRunIds"] = [];
            for (let item of this.payrollRunIds)
                data["payrollRunIds"].push(item);
        }
        data["payrollJobId"] = this.payrollJobId;
        data["payrollSystem"] = this.payrollSystem;
        return data;
    }
}

export interface IBatchReviewEnqueueRequest {
    action?: BatchReviewAction;
    payrollRunIds?: string[] | undefined;
    payrollJobId?: string | undefined;
    payrollSystem?: string | undefined;
}

export class BatchReviewRequest implements IBatchReviewRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollRunId?: string | undefined;
    payrollSystem?: string | undefined;
    batchStatus?: string | undefined;

    constructor(data?: IBatchReviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.payrollRunId = _data["payrollRunId"];
            this.payrollSystem = _data["payrollSystem"];
            this.batchStatus = _data["batchStatus"];
        }
    }

    static fromJS(data: any): BatchReviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["payrollRunId"] = this.payrollRunId;
        data["payrollSystem"] = this.payrollSystem;
        data["batchStatus"] = this.batchStatus;
        return data;
    }
}

export interface IBatchReviewRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollRunId?: string | undefined;
    payrollSystem?: string | undefined;
    batchStatus?: string | undefined;
}

export class BatchReviewSearchRequest implements IBatchReviewSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollSystem?: string | undefined;
    payors?: string[] | undefined;
    caregiverIds?: number[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    isTimeWorked?: boolean;
    isAbsence?: boolean;
    estimatedPayDate?: Date | undefined;

    constructor(data?: IBatchReviewSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.payrollSystem = _data["payrollSystem"];
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(item);
            }
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.isTimeWorked = _data["isTimeWorked"];
            this.isAbsence = _data["isAbsence"];
            this.estimatedPayDate = _data["estimatedPayDate"] ? new Date(_data["estimatedPayDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchReviewSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["payrollSystem"] = this.payrollSystem;
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item);
        }
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["isTimeWorked"] = this.isTimeWorked;
        data["isAbsence"] = this.isAbsence;
        data["estimatedPayDate"] = this.estimatedPayDate ? this.estimatedPayDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatchReviewSearchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollSystem?: string | undefined;
    payors?: string[] | undefined;
    caregiverIds?: number[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    isTimeWorked?: boolean;
    isAbsence?: boolean;
    estimatedPayDate?: Date | undefined;
}

export class BatchReviewTotals implements IBatchReviewTotals {
    earningCode?: string | undefined;
    aggregateCount?: number;
    payUnits?: number;
    payAmount?: number;

    constructor(data?: IBatchReviewTotals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.earningCode = _data["earningCode"];
            this.aggregateCount = _data["aggregateCount"];
            this.payUnits = _data["payUnits"];
            this.payAmount = _data["payAmount"];
        }
    }

    static fromJS(data: any): BatchReviewTotals {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReviewTotals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["earningCode"] = this.earningCode;
        data["aggregateCount"] = this.aggregateCount;
        data["payUnits"] = this.payUnits;
        data["payAmount"] = this.payAmount;
        return data;
    }
}

export interface IBatchReviewTotals {
    earningCode?: string | undefined;
    aggregateCount?: number;
    payUnits?: number;
    payAmount?: number;
}

export class BatchSummary implements IBatchSummary {
    caregiverCount?: number;
    totalPayAmount?: number;
    positivePayAmount?: number;
    negativePayAmount?: number;
    totalPcn?: number;
    totalNonExemptPcn?: number;
    totalExemptPcn?: number;
    totalHolidayPcn?: number;
    totalRecords?: number;
    mileage?: number;
    totalUnits?: number;

    constructor(data?: IBatchSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverCount = _data["caregiverCount"];
            this.totalPayAmount = _data["totalPayAmount"];
            this.positivePayAmount = _data["positivePayAmount"];
            this.negativePayAmount = _data["negativePayAmount"];
            this.totalPcn = _data["totalPcn"];
            this.totalNonExemptPcn = _data["totalNonExemptPcn"];
            this.totalExemptPcn = _data["totalExemptPcn"];
            this.totalHolidayPcn = _data["totalHolidayPcn"];
            this.totalRecords = _data["totalRecords"];
            this.mileage = _data["mileage"];
            this.totalUnits = _data["totalUnits"];
        }
    }

    static fromJS(data: any): BatchSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverCount"] = this.caregiverCount;
        data["totalPayAmount"] = this.totalPayAmount;
        data["positivePayAmount"] = this.positivePayAmount;
        data["negativePayAmount"] = this.negativePayAmount;
        data["totalPcn"] = this.totalPcn;
        data["totalNonExemptPcn"] = this.totalNonExemptPcn;
        data["totalExemptPcn"] = this.totalExemptPcn;
        data["totalHolidayPcn"] = this.totalHolidayPcn;
        data["totalRecords"] = this.totalRecords;
        data["mileage"] = this.mileage;
        data["totalUnits"] = this.totalUnits;
        return data;
    }
}

export interface IBatchSummary {
    caregiverCount?: number;
    totalPayAmount?: number;
    positivePayAmount?: number;
    negativePayAmount?: number;
    totalPcn?: number;
    totalNonExemptPcn?: number;
    totalExemptPcn?: number;
    totalHolidayPcn?: number;
    totalRecords?: number;
    mileage?: number;
    totalUnits?: number;
}

export enum CallingConventions {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

export class CareerHourPayRateData implements ICareerHourPayRateData {
    id?: number;
    dateBegin?: Date;
    dateEnd?: Date;
    cumulativeCareerHourStart?: number;
    cumulativeCareerHourEnd?: number;
    baseRate?: number;
    differential?: string | undefined;
    differentialRate?: number;
    isStackable?: boolean;
    qualification?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ICareerHourPayRateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.cumulativeCareerHourStart = _data["cumulativeCareerHourStart"];
            this.cumulativeCareerHourEnd = _data["cumulativeCareerHourEnd"];
            this.baseRate = _data["baseRate"];
            this.differential = _data["differential"];
            this.differentialRate = _data["differentialRate"];
            this.isStackable = _data["isStackable"];
            this.qualification = _data["qualification"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourPayRateData {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourPayRateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["cumulativeCareerHourStart"] = this.cumulativeCareerHourStart;
        data["cumulativeCareerHourEnd"] = this.cumulativeCareerHourEnd;
        data["baseRate"] = this.baseRate;
        data["differential"] = this.differential;
        data["differentialRate"] = this.differentialRate;
        data["isStackable"] = this.isStackable;
        data["qualification"] = this.qualification;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourPayRateData {
    id?: number;
    dateBegin?: Date;
    dateEnd?: Date;
    cumulativeCareerHourStart?: number;
    cumulativeCareerHourEnd?: number;
    baseRate?: number;
    differential?: string | undefined;
    differentialRate?: number;
    isStackable?: boolean;
    qualification?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class CareerHourPayRateDomainModel implements ICareerHourPayRateDomainModel {
    concurrencyToken?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    careerHourRateModifierQualification?: CareerHourRateModifierQualificationEntity;
    careerHourRateModifier?: CareerHourRateModifierEntity;
    careerHourRatePeriod?: CareerHourRatePeriodEntity;
    careerHourRate?: CareerHourRateEntity;
    qualificationType?: QualificationTypeEntity;
    readonly id?: number;
    dateRange?: DateRange;
    readonly dateBegin?: Date;
    readonly dateEnd?: Date;
    readonly baseRate?: number;
    readonly cumulativeCareerHourStart?: number;
    readonly cumulativeCareerHourEnd?: number;
    readonly differential?: string | undefined;
    readonly differentialRate?: number;
    readonly isStackable?: boolean;
    readonly qualification?: string | undefined;

    constructor(data?: ICareerHourPayRateDomainModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.concurrencyToken = _data["concurrencyToken"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.careerHourRateModifierQualification = _data["careerHourRateModifierQualification"] ? CareerHourRateModifierQualificationEntity.fromJS(_data["careerHourRateModifierQualification"]) : <any>undefined;
            this.careerHourRateModifier = _data["careerHourRateModifier"] ? CareerHourRateModifierEntity.fromJS(_data["careerHourRateModifier"]) : <any>undefined;
            this.careerHourRatePeriod = _data["careerHourRatePeriod"] ? CareerHourRatePeriodEntity.fromJS(_data["careerHourRatePeriod"]) : <any>undefined;
            this.careerHourRate = _data["careerHourRate"] ? CareerHourRateEntity.fromJS(_data["careerHourRate"]) : <any>undefined;
            this.qualificationType = _data["qualificationType"] ? QualificationTypeEntity.fromJS(_data["qualificationType"]) : <any>undefined;
            (<any>this).id = _data["id"];
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : <any>undefined;
            (<any>this).dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            (<any>this).dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            (<any>this).baseRate = _data["baseRate"];
            (<any>this).cumulativeCareerHourStart = _data["cumulativeCareerHourStart"];
            (<any>this).cumulativeCareerHourEnd = _data["cumulativeCareerHourEnd"];
            (<any>this).differential = _data["differential"];
            (<any>this).differentialRate = _data["differentialRate"];
            (<any>this).isStackable = _data["isStackable"];
            (<any>this).qualification = _data["qualification"];
        }
    }

    static fromJS(data: any): CareerHourPayRateDomainModel {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourPayRateDomainModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["concurrencyToken"] = this.concurrencyToken;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["careerHourRateModifierQualification"] = this.careerHourRateModifierQualification ? this.careerHourRateModifierQualification.toJSON() : <any>undefined;
        data["careerHourRateModifier"] = this.careerHourRateModifier ? this.careerHourRateModifier.toJSON() : <any>undefined;
        data["careerHourRatePeriod"] = this.careerHourRatePeriod ? this.careerHourRatePeriod.toJSON() : <any>undefined;
        data["careerHourRate"] = this.careerHourRate ? this.careerHourRate.toJSON() : <any>undefined;
        data["qualificationType"] = this.qualificationType ? this.qualificationType.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : <any>undefined;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["baseRate"] = this.baseRate;
        data["cumulativeCareerHourStart"] = this.cumulativeCareerHourStart;
        data["cumulativeCareerHourEnd"] = this.cumulativeCareerHourEnd;
        data["differential"] = this.differential;
        data["differentialRate"] = this.differentialRate;
        data["isStackable"] = this.isStackable;
        data["qualification"] = this.qualification;
        return data;
    }
}

export interface ICareerHourPayRateDomainModel {
    concurrencyToken?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean;
    careerHourRateModifierQualification?: CareerHourRateModifierQualificationEntity;
    careerHourRateModifier?: CareerHourRateModifierEntity;
    careerHourRatePeriod?: CareerHourRatePeriodEntity;
    careerHourRate?: CareerHourRateEntity;
    qualificationType?: QualificationTypeEntity;
    id?: number;
    dateRange?: DateRange;
    dateBegin?: Date;
    dateEnd?: Date;
    baseRate?: number;
    cumulativeCareerHourStart?: number;
    cumulativeCareerHourEnd?: number;
    differential?: string | undefined;
    differentialRate?: number;
    isStackable?: boolean;
    qualification?: string | undefined;
}

export class CareerHourRateDto implements ICareerHourRateDto {
    careerHourRateId?: number;
    careerHourRatePeriodId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ICareerHourRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateId = _data["careerHourRateId"];
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
            this.rateBase = _data["rateBase"];
            this.clientEntityId = _data["clientEntityId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateId"] = this.careerHourRateId;
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["rateBase"] = this.rateBase;
        data["clientEntityId"] = this.clientEntityId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRateDto {
    careerHourRateId?: number;
    careerHourRatePeriodId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
}

export class CareerHourRateEntity implements ICareerHourRateEntity {
    id?: number;
    careerHourRatePeriodId?: number;
    careerHourRange?: CumulativeCareerHourRange;
    readonly minHours?: number;
    readonly maxHours?: number;
    rateBase?: number;

    constructor(data?: ICareerHourRateEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.careerHourRange = _data["careerHourRange"] ? CumulativeCareerHourRange.fromJS(_data["careerHourRange"]) : <any>undefined;
            (<any>this).minHours = _data["minHours"];
            (<any>this).maxHours = _data["maxHours"];
            this.rateBase = _data["rateBase"];
        }
    }

    static fromJS(data: any): CareerHourRateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["careerHourRange"] = this.careerHourRange ? this.careerHourRange.toJSON() : <any>undefined;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["rateBase"] = this.rateBase;
        return data;
    }
}

export interface ICareerHourRateEntity {
    id?: number;
    careerHourRatePeriodId?: number;
    careerHourRange?: CumulativeCareerHourRange;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
}

export class CareerHourRateInfo implements ICareerHourRateInfo {
    startDate?: Date;
    differential?: string | undefined;
    endDate?: Date;
    periodCreatedOn?: Date;
    periodUpdatedOn?: Date;
    careerHourRatePeriodId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    rateCreatedOn?: Date | undefined;
    rateUpdatedOn?: Date | undefined;
    careerHourRateId?: number;
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    rateModifier?: number;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    careerHourRateModifierId?: number;
    careerHourRateModifierQualificationId?: number | undefined;
    rateModifiers?: RateModifierQualification[] | undefined;
    isStackable?: boolean;

    constructor(data?: ICareerHourRateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.differential = _data["differential"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.periodCreatedOn = _data["periodCreatedOn"] ? new Date(_data["periodCreatedOn"].toString()) : <any>undefined;
            this.periodUpdatedOn = _data["periodUpdatedOn"] ? new Date(_data["periodUpdatedOn"].toString()) : <any>undefined;
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
            this.rateBase = _data["rateBase"];
            this.rateCreatedOn = _data["rateCreatedOn"] ? new Date(_data["rateCreatedOn"].toString()) : <any>undefined;
            this.rateUpdatedOn = _data["rateUpdatedOn"] ? new Date(_data["rateUpdatedOn"].toString()) : <any>undefined;
            this.careerHourRateId = _data["careerHourRateId"];
            this.modifierCreatedOn = _data["modifierCreatedOn"] ? new Date(_data["modifierCreatedOn"].toString()) : <any>undefined;
            this.modifierUpdatedOn = _data["modifierUpdatedOn"] ? new Date(_data["modifierUpdatedOn"].toString()) : <any>undefined;
            this.rateModifier = _data["rateModifier"];
            this.qualificationCreatedOn = _data["qualificationCreatedOn"] ? new Date(_data["qualificationCreatedOn"].toString()) : <any>undefined;
            this.qualificationUpdatedOn = _data["qualificationUpdatedOn"] ? new Date(_data["qualificationUpdatedOn"].toString()) : <any>undefined;
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            if (Array.isArray(_data["rateModifiers"])) {
                this.rateModifiers = [] as any;
                for (let item of _data["rateModifiers"])
                    this.rateModifiers!.push(RateModifierQualification.fromJS(item));
            }
            this.isStackable = _data["isStackable"];
        }
    }

    static fromJS(data: any): CareerHourRateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["differential"] = this.differential;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["periodCreatedOn"] = this.periodCreatedOn ? this.periodCreatedOn.toISOString() : <any>undefined;
        data["periodUpdatedOn"] = this.periodUpdatedOn ? this.periodUpdatedOn.toISOString() : <any>undefined;
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["rateBase"] = this.rateBase;
        data["rateCreatedOn"] = this.rateCreatedOn ? this.rateCreatedOn.toISOString() : <any>undefined;
        data["rateUpdatedOn"] = this.rateUpdatedOn ? this.rateUpdatedOn.toISOString() : <any>undefined;
        data["careerHourRateId"] = this.careerHourRateId;
        data["modifierCreatedOn"] = this.modifierCreatedOn ? this.modifierCreatedOn.toISOString() : <any>undefined;
        data["modifierUpdatedOn"] = this.modifierUpdatedOn ? this.modifierUpdatedOn.toISOString() : <any>undefined;
        data["rateModifier"] = this.rateModifier;
        data["qualificationCreatedOn"] = this.qualificationCreatedOn ? this.qualificationCreatedOn.toISOString() : <any>undefined;
        data["qualificationUpdatedOn"] = this.qualificationUpdatedOn ? this.qualificationUpdatedOn.toISOString() : <any>undefined;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        if (Array.isArray(this.rateModifiers)) {
            data["rateModifiers"] = [];
            for (let item of this.rateModifiers)
                data["rateModifiers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isStackable"] = this.isStackable;
        return data;
    }
}

export interface ICareerHourRateInfo {
    startDate?: Date;
    differential?: string | undefined;
    endDate?: Date;
    periodCreatedOn?: Date;
    periodUpdatedOn?: Date;
    careerHourRatePeriodId?: number;
    minHours?: number;
    maxHours?: number;
    rateBase?: number;
    rateCreatedOn?: Date | undefined;
    rateUpdatedOn?: Date | undefined;
    careerHourRateId?: number;
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    rateModifier?: number;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    careerHourRateModifierId?: number;
    careerHourRateModifierQualificationId?: number | undefined;
    rateModifiers?: RateModifierQualification[] | undefined;
    isStackable?: boolean;
}

export class CareerHourRateModifierDto implements ICareerHourRateModifierDto {
    careerHourRateModifierId?: number;
    careerHourRateId?: number;
    differential?: string | undefined;
    rateModifier?: number;
    isStackable?: boolean;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ICareerHourRateModifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.careerHourRateId = _data["careerHourRateId"];
            this.differential = _data["differential"];
            this.rateModifier = _data["rateModifier"];
            this.isStackable = _data["isStackable"];
            this.clientEntityId = _data["clientEntityId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRateModifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["careerHourRateId"] = this.careerHourRateId;
        data["differential"] = this.differential;
        data["rateModifier"] = this.rateModifier;
        data["isStackable"] = this.isStackable;
        data["clientEntityId"] = this.clientEntityId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRateModifierDto {
    careerHourRateModifierId?: number;
    careerHourRateId?: number;
    differential?: string | undefined;
    rateModifier?: number;
    isStackable?: boolean;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
}

export class CareerHourRateModifierEntity implements ICareerHourRateModifierEntity {
    id?: number;
    careerHourRateId?: number;
    differential?: string | undefined;
    rateModifier?: number;
    isStackable?: boolean;

    constructor(data?: ICareerHourRateModifierEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.careerHourRateId = _data["careerHourRateId"];
            this.differential = _data["differential"];
            this.rateModifier = _data["rateModifier"];
            this.isStackable = _data["isStackable"];
        }
    }

    static fromJS(data: any): CareerHourRateModifierEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["careerHourRateId"] = this.careerHourRateId;
        data["differential"] = this.differential;
        data["rateModifier"] = this.rateModifier;
        data["isStackable"] = this.isStackable;
        return data;
    }
}

export interface ICareerHourRateModifierEntity {
    id?: number;
    careerHourRateId?: number;
    differential?: string | undefined;
    rateModifier?: number;
    isStackable?: boolean;
}

export class CareerHourRateModifierQualificationDto implements ICareerHourRateModifierQualificationDto {
    careerHourRateModifierQualificationId?: number;
    careerHourRateModifierId?: number;
    qualificationId?: number;
    qualificationDisplayText?: string | undefined;
    companyId?: number;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ICareerHourRateModifierQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.qualificationId = _data["qualificationId"];
            this.qualificationDisplayText = _data["qualificationDisplayText"];
            this.companyId = _data["companyId"];
            this.clientEntityId = _data["clientEntityId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRateModifierQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["qualificationId"] = this.qualificationId;
        data["qualificationDisplayText"] = this.qualificationDisplayText;
        data["companyId"] = this.companyId;
        data["clientEntityId"] = this.clientEntityId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRateModifierQualificationDto {
    careerHourRateModifierQualificationId?: number;
    careerHourRateModifierId?: number;
    qualificationId?: number;
    qualificationDisplayText?: string | undefined;
    companyId?: number;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
}

export class CareerHourRateModifierQualificationEntity implements ICareerHourRateModifierQualificationEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    id?: number;
    careerHourRateModifierId?: number;
    qualificationTypeId?: number;

    constructor(data?: ICareerHourRateModifierQualificationEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.qualificationTypeId = _data["qualificationTypeId"];
        }
    }

    static fromJS(data: any): CareerHourRateModifierQualificationEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRateModifierQualificationEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["qualificationTypeId"] = this.qualificationTypeId;
        return data;
    }
}

export interface ICareerHourRateModifierQualificationEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    id?: number;
    careerHourRateModifierId?: number;
    qualificationTypeId?: number;
}

export class CareerHourRatePeriodDto implements ICareerHourRatePeriodDto {
    careerHourRatePeriodId?: number;
    startDate?: Date;
    endDate?: Date;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: ICareerHourRatePeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careerHourRatePeriodId = _data["careerHourRatePeriodId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.clientEntityId = _data["clientEntityId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRatePeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRatePeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careerHourRatePeriodId"] = this.careerHourRatePeriodId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["clientEntityId"] = this.clientEntityId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRatePeriodDto {
    careerHourRatePeriodId?: number;
    startDate?: Date;
    endDate?: Date;
    clientEntityId?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
}

export class CareerHourRatePeriodEntity implements ICareerHourRatePeriodEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    id?: number;
    dateRange?: DateRange;
    readonly startDate?: Date;
    readonly endDate?: Date;

    constructor(data?: ICareerHourRatePeriodEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.dateRange = _data["dateRange"] ? DateRange.fromJS(_data["dateRange"]) : <any>undefined;
            (<any>this).startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            (<any>this).endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CareerHourRatePeriodEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CareerHourRatePeriodEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICareerHourRatePeriodEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    id?: number;
    dateRange?: DateRange;
    startDate?: Date;
    endDate?: Date;
}

export class CchRateHistoryHolder implements ICchRateHistoryHolder {
    caregiverId?: number;
    caregiverEmployerMappingId?: number;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    totalCareerHours?: number;
    cchRateHistory?: RateHistoryBaseResponse[] | undefined;

    constructor(data?: ICchRateHistoryHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.totalCareerHours = _data["totalCareerHours"];
            if (Array.isArray(_data["cchRateHistory"])) {
                this.cchRateHistory = [] as any;
                for (let item of _data["cchRateHistory"])
                    this.cchRateHistory!.push(RateHistoryBaseResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CchRateHistoryHolder {
        data = typeof data === 'object' ? data : {};
        let result = new CchRateHistoryHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["totalCareerHours"] = this.totalCareerHours;
        if (Array.isArray(this.cchRateHistory)) {
            data["cchRateHistory"] = [];
            for (let item of this.cchRateHistory)
                data["cchRateHistory"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICchRateHistoryHolder {
    caregiverId?: number;
    caregiverEmployerMappingId?: number;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    totalCareerHours?: number;
    cchRateHistory?: RateHistoryBaseResponse[] | undefined;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }
}

export interface IConstructorInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
}

export class CreatePayrollBatchRequest implements ICreatePayrollBatchRequest {
    payrollSystem?: string | undefined;
    payors?: string[] | undefined;
    isEPR?: boolean;
    caregiverIds?: number[] | undefined;
    serviceCodes?: string[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date;
    cutoffDate?: Date | undefined;
    isolationId?: string | undefined;
    payrollRunId?: string | undefined;
    isTimeWorked?: boolean;
    isAbsence?: boolean;
    excludedRecords?: ExcludedRecordEntry[] | undefined;
    readonly excludedRecordIds?: number[] | undefined;
    reincludedRecordIds?: number[] | undefined;
    estimatedPayDate?: Date;
    isIncludeNetNegative?: boolean;
    excludeSelectedServiceCodes?: boolean;
    isValidatePayUnits?: boolean;
    isValidateDistinctWorkerCounts?: boolean;
    isExcludedLockedByShiftAdjustment?: boolean;

    constructor(data?: ICreatePayrollBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollSystem = _data["payrollSystem"];
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(item);
            }
            this.isEPR = _data["isEPR"];
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            if (Array.isArray(_data["serviceCodes"])) {
                this.serviceCodes = [] as any;
                for (let item of _data["serviceCodes"])
                    this.serviceCodes!.push(item);
            }
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.cutoffDate = _data["cutoffDate"] ? new Date(_data["cutoffDate"].toString()) : <any>undefined;
            this.isolationId = _data["isolationId"];
            this.payrollRunId = _data["payrollRunId"];
            this.isTimeWorked = _data["isTimeWorked"];
            this.isAbsence = _data["isAbsence"];
            if (Array.isArray(_data["excludedRecords"])) {
                this.excludedRecords = [] as any;
                for (let item of _data["excludedRecords"])
                    this.excludedRecords!.push(ExcludedRecordEntry.fromJS(item));
            }
            if (Array.isArray(_data["excludedRecordIds"])) {
                (<any>this).excludedRecordIds = [] as any;
                for (let item of _data["excludedRecordIds"])
                    (<any>this).excludedRecordIds!.push(item);
            }
            if (Array.isArray(_data["reincludedRecordIds"])) {
                this.reincludedRecordIds = [] as any;
                for (let item of _data["reincludedRecordIds"])
                    this.reincludedRecordIds!.push(item);
            }
            this.estimatedPayDate = _data["estimatedPayDate"] ? new Date(_data["estimatedPayDate"].toString()) : <any>undefined;
            this.isIncludeNetNegative = _data["isIncludeNetNegative"];
            this.excludeSelectedServiceCodes = _data["excludeSelectedServiceCodes"];
            this.isValidatePayUnits = _data["isValidatePayUnits"];
            this.isValidateDistinctWorkerCounts = _data["isValidateDistinctWorkerCounts"];
            this.isExcludedLockedByShiftAdjustment = _data["isExcludedLockedByShiftAdjustment"];
        }
    }

    static fromJS(data: any): CreatePayrollBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePayrollBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollSystem"] = this.payrollSystem;
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item);
        }
        data["isEPR"] = this.isEPR;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        if (Array.isArray(this.serviceCodes)) {
            data["serviceCodes"] = [];
            for (let item of this.serviceCodes)
                data["serviceCodes"].push(item);
        }
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["isolationId"] = this.isolationId;
        data["payrollRunId"] = this.payrollRunId;
        data["isTimeWorked"] = this.isTimeWorked;
        data["isAbsence"] = this.isAbsence;
        if (Array.isArray(this.excludedRecords)) {
            data["excludedRecords"] = [];
            for (let item of this.excludedRecords)
                data["excludedRecords"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.excludedRecordIds)) {
            data["excludedRecordIds"] = [];
            for (let item of this.excludedRecordIds)
                data["excludedRecordIds"].push(item);
        }
        if (Array.isArray(this.reincludedRecordIds)) {
            data["reincludedRecordIds"] = [];
            for (let item of this.reincludedRecordIds)
                data["reincludedRecordIds"].push(item);
        }
        data["estimatedPayDate"] = this.estimatedPayDate ? this.estimatedPayDate.toISOString() : <any>undefined;
        data["isIncludeNetNegative"] = this.isIncludeNetNegative;
        data["excludeSelectedServiceCodes"] = this.excludeSelectedServiceCodes;
        data["isValidatePayUnits"] = this.isValidatePayUnits;
        data["isValidateDistinctWorkerCounts"] = this.isValidateDistinctWorkerCounts;
        data["isExcludedLockedByShiftAdjustment"] = this.isExcludedLockedByShiftAdjustment;
        return data;
    }
}

export interface ICreatePayrollBatchRequest {
    payrollSystem?: string | undefined;
    payors?: string[] | undefined;
    isEPR?: boolean;
    caregiverIds?: number[] | undefined;
    serviceCodes?: string[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date;
    cutoffDate?: Date | undefined;
    isolationId?: string | undefined;
    payrollRunId?: string | undefined;
    isTimeWorked?: boolean;
    isAbsence?: boolean;
    excludedRecords?: ExcludedRecordEntry[] | undefined;
    excludedRecordIds?: number[] | undefined;
    reincludedRecordIds?: number[] | undefined;
    estimatedPayDate?: Date;
    isIncludeNetNegative?: boolean;
    excludeSelectedServiceCodes?: boolean;
    isValidatePayUnits?: boolean;
    isValidateDistinctWorkerCounts?: boolean;
    isExcludedLockedByShiftAdjustment?: boolean;
}

export class CumulativeCareerHourRange implements ICumulativeCareerHourRange {
    minHours?: number;
    maxHours?: number;

    constructor(data?: ICumulativeCareerHourRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
        }
    }

    static fromJS(data: any): CumulativeCareerHourRange {
        data = typeof data === 'object' ? data : {};
        let result = new CumulativeCareerHourRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        return data;
    }
}

export interface ICumulativeCareerHourRange {
    minHours?: number;
    maxHours?: number;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    readonly constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments?: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : <any>undefined;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    readonly memberName?: string | undefined;
    readonly isField?: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string | undefined;
    isField?: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;
}

export class DateRange implements IDateRange {
    startDate?: Date;
    endDate?: Date;
    isManual?: boolean;
    id?: string | undefined;

    constructor(data?: IDateRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.isManual = _data["isManual"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DateRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isManual"] = this.isManual;
        data["id"] = this.id;
        return data;
    }
}

export interface IDateRange {
    startDate?: Date;
    endDate?: Date;
    isManual?: boolean;
    id?: string | undefined;
}

export class DeleteRequestLockedTcns implements IDeleteRequestLockedTcns {
    tcns?: string[] | undefined;
    batchId?: string | undefined;

    constructor(data?: IDeleteRequestLockedTcns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcns"])) {
                this.tcns = [] as any;
                for (let item of _data["tcns"])
                    this.tcns!.push(item);
            }
            this.batchId = _data["batchId"];
        }
    }

    static fromJS(data: any): DeleteRequestLockedTcns {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequestLockedTcns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcns)) {
            data["tcns"] = [];
            for (let item of this.tcns)
                data["tcns"].push(item);
        }
        data["batchId"] = this.batchId;
        return data;
    }
}

export interface IDeleteRequestLockedTcns {
    tcns?: string[] | undefined;
    batchId?: string | undefined;
}

export class DeleteServeEarnMappingRequest implements IDeleteServeEarnMappingRequest {
    serviceCode?: string | undefined;
    earningType?: string | undefined;

    constructor(data?: IDeleteServeEarnMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCode = _data["serviceCode"];
            this.earningType = _data["earningType"];
        }
    }

    static fromJS(data: any): DeleteServeEarnMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteServeEarnMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCode"] = this.serviceCode;
        data["earningType"] = this.earningType;
        return data;
    }
}

export interface IDeleteServeEarnMappingRequest {
    serviceCode?: string | undefined;
    earningType?: string | undefined;
}

export class EPRRecordRequest implements IEPRRecordRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    participantId?: string | undefined;
    caregiverId?: number;
    servcode?: string | undefined;
    flsaStartDate?: Date | undefined;
    flsaEndDate?: Date;
    caregiverEmployerMappingId?: number;
    reason?: string | undefined;

    constructor(data?: IEPRRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.servcode = _data["servcode"];
            this.flsaStartDate = _data["flsaStartDate"] ? new Date(_data["flsaStartDate"].toString()) : <any>undefined;
            this.flsaEndDate = _data["flsaEndDate"] ? new Date(_data["flsaEndDate"].toString()) : <any>undefined;
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): EPRRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EPRRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["servcode"] = this.servcode;
        data["flsaStartDate"] = this.flsaStartDate ? this.flsaStartDate.toISOString() : <any>undefined;
        data["flsaEndDate"] = this.flsaEndDate ? this.flsaEndDate.toISOString() : <any>undefined;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IEPRRecordRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    participantId?: string | undefined;
    caregiverId?: number;
    servcode?: string | undefined;
    flsaStartDate?: Date | undefined;
    flsaEndDate?: Date;
    caregiverEmployerMappingId?: number;
    reason?: string | undefined;
}

export class EPRRecordsResponse implements IEPRRecordsResponse {
    id?: number;
    pcn?: string | undefined;
    refPCN?: string | undefined;
    tcn?: string | undefined;
    prbcnId?: number | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    payorCode?: string | undefined;
    status?: number;
    readonly statusText?: string | undefined;
    payDate?: Date | undefined;
    receivedDate?: Date | undefined;
    totalPayAmount?: number | undefined;
    calculatedAmount?: number | undefined;
    unitsReg?: number | undefined;
    payRate?: number | undefined;
    taxTotal?: number | undefined;
    serviceDate?: Date | undefined;
    servCode?: string | undefined;
    checkNbr?: string | undefined;
    checkdate?: Date | undefined;
    calHrs?: number | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    companyId?: number | undefined;
    isAdjusted?: boolean | undefined;
    pcnSubStatus?: number;
    readonly pcnSubStatusText?: string | undefined;
    payReg?: number;
    isPositive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    payUnits?: number;
    caregiverEmployerMappingId?: number;
    flsaWeekStart?: Date;
    flsaWeekEnd?: Date;
    isEpr?: boolean;
    reason?: string | undefined;

    constructor(data?: IEPRRecordsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pcn = _data["pcn"];
            this.refPCN = _data["refPCN"];
            this.tcn = _data["tcn"];
            this.prbcnId = _data["prbcnId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.payorCode = _data["payorCode"];
            this.status = _data["status"];
            (<any>this).statusText = _data["statusText"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.totalPayAmount = _data["totalPayAmount"];
            this.calculatedAmount = _data["calculatedAmount"];
            this.unitsReg = _data["unitsReg"];
            this.payRate = _data["payRate"];
            this.taxTotal = _data["taxTotal"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.servCode = _data["servCode"];
            this.checkNbr = _data["checkNbr"];
            this.checkdate = _data["checkdate"] ? new Date(_data["checkdate"].toString()) : <any>undefined;
            this.calHrs = _data["calHrs"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.companyId = _data["companyId"];
            this.isAdjusted = _data["isAdjusted"];
            this.pcnSubStatus = _data["pcnSubStatus"];
            (<any>this).pcnSubStatusText = _data["pcnSubStatusText"];
            this.payReg = _data["payReg"];
            this.isPositive = _data["isPositive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.payUnits = _data["payUnits"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.flsaWeekStart = _data["flsaWeekStart"] ? new Date(_data["flsaWeekStart"].toString()) : <any>undefined;
            this.flsaWeekEnd = _data["flsaWeekEnd"] ? new Date(_data["flsaWeekEnd"].toString()) : <any>undefined;
            this.isEpr = _data["isEpr"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): EPRRecordsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EPRRecordsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pcn"] = this.pcn;
        data["refPCN"] = this.refPCN;
        data["tcn"] = this.tcn;
        data["prbcnId"] = this.prbcnId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["payorCode"] = this.payorCode;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["totalPayAmount"] = this.totalPayAmount;
        data["calculatedAmount"] = this.calculatedAmount;
        data["unitsReg"] = this.unitsReg;
        data["payRate"] = this.payRate;
        data["taxTotal"] = this.taxTotal;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["servCode"] = this.servCode;
        data["checkNbr"] = this.checkNbr;
        data["checkdate"] = this.checkdate ? this.checkdate.toISOString() : <any>undefined;
        data["calHrs"] = this.calHrs;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["companyId"] = this.companyId;
        data["isAdjusted"] = this.isAdjusted;
        data["pcnSubStatus"] = this.pcnSubStatus;
        data["pcnSubStatusText"] = this.pcnSubStatusText;
        data["payReg"] = this.payReg;
        data["isPositive"] = this.isPositive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["payUnits"] = this.payUnits;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["flsaWeekStart"] = this.flsaWeekStart ? this.flsaWeekStart.toISOString() : <any>undefined;
        data["flsaWeekEnd"] = this.flsaWeekEnd ? this.flsaWeekEnd.toISOString() : <any>undefined;
        data["isEpr"] = this.isEpr;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IEPRRecordsResponse {
    id?: number;
    pcn?: string | undefined;
    refPCN?: string | undefined;
    tcn?: string | undefined;
    prbcnId?: number | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    payorCode?: string | undefined;
    status?: number;
    statusText?: string | undefined;
    payDate?: Date | undefined;
    receivedDate?: Date | undefined;
    totalPayAmount?: number | undefined;
    calculatedAmount?: number | undefined;
    unitsReg?: number | undefined;
    payRate?: number | undefined;
    taxTotal?: number | undefined;
    serviceDate?: Date | undefined;
    servCode?: string | undefined;
    checkNbr?: string | undefined;
    checkdate?: Date | undefined;
    calHrs?: number | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    companyId?: number | undefined;
    isAdjusted?: boolean | undefined;
    pcnSubStatus?: number;
    pcnSubStatusText?: string | undefined;
    payReg?: number;
    isPositive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    payUnits?: number;
    caregiverEmployerMappingId?: number;
    flsaWeekStart?: Date;
    flsaWeekEnd?: Date;
    isEpr?: boolean;
    reason?: string | undefined;
}

export class EPRRecordsResponseGridResponseBase implements IEPRRecordsResponseGridResponseBase {
    items?: EPRRecordsResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EPRRecordsResponse;

    constructor(data?: IEPRRecordsResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EPRRecordsResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? EPRRecordsResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EPRRecordsResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new EPRRecordsResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEPRRecordsResponseGridResponseBase {
    items?: EPRRecordsResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EPRRecordsResponse;
}

export class EPRUpsertRequest implements IEPRUpsertRequest {
    requests?: EPRRecordRequest[] | undefined;
    isSet?: boolean;

    constructor(data?: IEPRUpsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(EPRRecordRequest.fromJS(item));
            }
            this.isSet = _data["isSet"];
        }
    }

    static fromJS(data: any): EPRUpsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EPRUpsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isSet"] = this.isSet;
        return data;
    }
}

export interface IEPRUpsertRequest {
    requests?: EPRRecordRequest[] | undefined;
    isSet?: boolean;
}

export class EmployerCostRateDto implements IEmployerCostRateDto {
    id?: number;
    deductionId?: string | undefined;
    description?: string | undefined;
    percentage?: number;
    validFrom?: Date;
    validTo?: Date;
    isDeleted?: boolean;

    constructor(data?: IEmployerCostRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deductionId = _data["deductionId"];
            this.description = _data["description"];
            this.percentage = _data["percentage"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): EmployerCostRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerCostRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deductionId"] = this.deductionId;
        data["description"] = this.description;
        data["percentage"] = this.percentage;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IEmployerCostRateDto {
    id?: number;
    deductionId?: string | undefined;
    description?: string | undefined;
    percentage?: number;
    validFrom?: Date;
    validTo?: Date;
    isDeleted?: boolean;
}

export class EmployerCostRateEntity implements IEmployerCostRateEntity {
    concurrencyToken?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    id?: number;
    deductionId?: string | undefined;
    description?: string | undefined;
    percentage?: number;
    validFrom?: Date;
    validTo?: Date;
    isDeleted?: boolean;

    constructor(data?: IEmployerCostRateEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.concurrencyToken = _data["concurrencyToken"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.deductionId = _data["deductionId"];
            this.description = _data["description"];
            this.percentage = _data["percentage"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): EmployerCostRateEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerCostRateEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["concurrencyToken"] = this.concurrencyToken;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["deductionId"] = this.deductionId;
        data["description"] = this.description;
        data["percentage"] = this.percentage;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IEmployerCostRateEntity {
    concurrencyToken?: string | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    id?: number;
    deductionId?: string | undefined;
    description?: string | undefined;
    percentage?: number;
    validFrom?: Date;
    validTo?: Date;
    isDeleted?: boolean;
}

export class EmployerCostRateEntityGridResponseBase implements IEmployerCostRateEntityGridResponseBase {
    items?: EmployerCostRateEntity[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerCostRateEntity;

    constructor(data?: IEmployerCostRateEntityGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmployerCostRateEntity.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? EmployerCostRateEntity.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerCostRateEntityGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerCostRateEntityGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployerCostRateEntityGridResponseBase {
    items?: EmployerCostRateEntity[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerCostRateEntity;
}

export class EmployerPayRateData implements IEmployerPayRateData {
    id?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    dateBegin?: Date;
    dateEnd?: Date;
    employerId?: number;
    ein?: string | undefined;
    payRate?: number;
    isActive?: boolean;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IEmployerPayRateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCode = _data["serviceCode"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.employerId = _data["employerId"];
            this.ein = _data["ein"];
            this.payRate = _data["payRate"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerPayRateData {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCode"] = this.serviceCode;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["employerId"] = this.employerId;
        data["ein"] = this.ein;
        data["payRate"] = this.payRate;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployerPayRateData {
    id?: number;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    dateBegin?: Date;
    dateEnd?: Date;
    employerId?: number;
    ein?: string | undefined;
    payRate?: number;
    isActive?: boolean;
    isDeleted?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class EmployerPayRateDataGridResponseBase implements IEmployerPayRateDataGridResponseBase {
    items?: EmployerPayRateData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerPayRateData;

    constructor(data?: IEmployerPayRateDataGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmployerPayRateData.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? EmployerPayRateData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployerPayRateDataGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new EmployerPayRateDataGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployerPayRateDataGridResponseBase {
    items?: EmployerPayRateData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: EmployerPayRateData;
}

export enum EventAttributes {
    None = "None",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
}

export class EventInfo implements IEventInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    readonly isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    readonly isMulticast?: boolean;
    eventHandlerType?: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : <any>undefined;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : <any>undefined;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : <any>undefined;
            (<any>this).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    isMulticast?: boolean;
    eventHandlerType?: Type;
}

export class Exception implements IException {
    targetSite?: MethodBase;
    readonly message?: string | undefined;
    readonly data?: { [key: string]: any; } | undefined;
    innerException?: Exception;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult?: number;
    readonly stackTrace?: string | undefined;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetSite = _data["targetSite"] ? MethodBase.fromJS(_data["targetSite"]) : <any>undefined;
            (<any>this).message = _data["message"];
            if (_data["data"]) {
                (<any>this).data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>(<any>this).data)![key] = _data["data"][key];
                }
            }
            this.innerException = _data["innerException"] ? Exception.fromJS(_data["innerException"]) : <any>undefined;
            this.helpLink = _data["helpLink"];
            this.source = _data["source"];
            this.hResult = _data["hResult"];
            (<any>this).stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetSite"] = this.targetSite ? this.targetSite.toJSON() : <any>undefined;
        data["message"] = this.message;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["innerException"] = this.innerException ? this.innerException.toJSON() : <any>undefined;
        data["helpLink"] = this.helpLink;
        data["source"] = this.source;
        data["hResult"] = this.hResult;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IException {
    targetSite?: MethodBase;
    message?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    innerException?: Exception;
    helpLink?: string | undefined;
    source?: string | undefined;
    hResult?: number;
    stackTrace?: string | undefined;
}

export class ExcludedBatchRecords implements IExcludedBatchRecords {
    startDate?: Date;
    endDate?: Date;
    exclusionReason?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
    payrollProgramId?: string | undefined;
    payUnits?: number;
    payRate?: string | undefined;

    constructor(data?: IExcludedBatchRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.exclusionReason = _data["exclusionReason"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverId = _data["caregiverId"];
            this.payrollProgramId = _data["payrollProgramId"];
            this.payUnits = _data["payUnits"];
            this.payRate = _data["payRate"];
        }
    }

    static fromJS(data: any): ExcludedBatchRecords {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedBatchRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["exclusionReason"] = this.exclusionReason;
        data["caregiverName"] = this.caregiverName;
        data["caregiverId"] = this.caregiverId;
        data["payrollProgramId"] = this.payrollProgramId;
        data["payUnits"] = this.payUnits;
        data["payRate"] = this.payRate;
        return data;
    }
}

export interface IExcludedBatchRecords {
    startDate?: Date;
    endDate?: Date;
    exclusionReason?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
    payrollProgramId?: string | undefined;
    payUnits?: number;
    payRate?: string | undefined;
}

export class ExcludedBatchRecordsGridResponseBase implements IExcludedBatchRecordsGridResponseBase {
    items?: ExcludedBatchRecords[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExcludedBatchRecords;

    constructor(data?: IExcludedBatchRecordsGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExcludedBatchRecords.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ExcludedBatchRecords.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcludedBatchRecordsGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedBatchRecordsGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExcludedBatchRecordsGridResponseBase {
    items?: ExcludedBatchRecords[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExcludedBatchRecords;
}

export class ExcludedRecordEntry implements IExcludedRecordEntry {
    id?: number;
    exclusion?: boolean;
    exclusionReason?: string | undefined;

    constructor(data?: IExcludedRecordEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exclusion = _data["exclusion"];
            this.exclusionReason = _data["exclusionReason"];
        }
    }

    static fromJS(data: any): ExcludedRecordEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedRecordEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exclusion"] = this.exclusion;
        data["exclusionReason"] = this.exclusionReason;
        return data;
    }
}

export interface IExcludedRecordEntry {
    id?: number;
    exclusion?: boolean;
    exclusionReason?: string | undefined;
}

export class ExcludedRecords implements IExcludedRecords {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollRunId?: string | undefined;

    constructor(data?: IExcludedRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.payrollRunId = _data["payrollRunId"];
        }
    }

    static fromJS(data: any): ExcludedRecords {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["payrollRunId"] = this.payrollRunId;
        return data;
    }
}

export interface IExcludedRecords {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollRunId?: string | undefined;
}

export class ExcludedRecordsInputRequest implements IExcludedRecordsInputRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollRunId?: string | undefined;
    batchStatus?: string | undefined;

    constructor(data?: IExcludedRecordsInputRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.payrollRunId = _data["payrollRunId"];
            this.batchStatus = _data["batchStatus"];
        }
    }

    static fromJS(data: any): ExcludedRecordsInputRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedRecordsInputRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["payrollRunId"] = this.payrollRunId;
        data["batchStatus"] = this.batchStatus;
        return data;
    }
}

export interface IExcludedRecordsInputRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    payrollRunId?: string | undefined;
    batchStatus?: string | undefined;
}

export class ExcludedRecordsResponse implements IExcludedRecordsResponse {
    exclusionReason?: string | undefined;
    payrollRecordId?: number;

    constructor(data?: IExcludedRecordsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exclusionReason = _data["exclusionReason"];
            this.payrollRecordId = _data["payrollRecordId"];
        }
    }

    static fromJS(data: any): ExcludedRecordsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedRecordsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exclusionReason"] = this.exclusionReason;
        data["payrollRecordId"] = this.payrollRecordId;
        return data;
    }
}

export interface IExcludedRecordsResponse {
    exclusionReason?: string | undefined;
    payrollRecordId?: number;
}

export class ExclusionCriteriaFilterRequest implements IExclusionCriteriaFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    searchParam?: string | undefined;

    constructor(data?: IExclusionCriteriaFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.searchParam = _data["searchParam"];
        }
    }

    static fromJS(data: any): ExclusionCriteriaFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionCriteriaFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["searchParam"] = this.searchParam;
        return data;
    }
}

export interface IExclusionCriteriaFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    searchParam?: string | undefined;
}

export class ExclusionCriterionEntry implements IExclusionCriterionEntry {
    id?: number;
    exclusionCriterion?: string | undefined;
    description?: string | undefined;

    constructor(data?: IExclusionCriterionEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.exclusionCriterion = _data["exclusionCriterion"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExclusionCriterionEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionCriterionEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exclusionCriterion"] = this.exclusionCriterion;
        data["description"] = this.description;
        return data;
    }
}

export interface IExclusionCriterionEntry {
    id?: number;
    exclusionCriterion?: string | undefined;
    description?: string | undefined;
}

export class ExclusionCriterionEntryGridResponseBase implements IExclusionCriterionEntryGridResponseBase {
    items?: ExclusionCriterionEntry[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExclusionCriterionEntry;

    constructor(data?: IExclusionCriterionEntryGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExclusionCriterionEntry.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ExclusionCriterionEntry.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExclusionCriterionEntryGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionCriterionEntryGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExclusionCriterionEntryGridResponseBase {
    items?: ExclusionCriterionEntry[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ExclusionCriterionEntry;
}

export enum ExclusionReasons {
    NeedsReview = "NeedsReview",
    UnderInvestigation = "UnderInvestigation",
    NetNegative = "NetNegative",
    NeverToBePaid = "NeverToBePaid",
    ShiftOutsideOfEmploymentDates = "ShiftOutsideOfEmploymentDates",
    CouldNotResolvePayRate = "CouldNotResolvePayRate",
    AdjustmentInProgress = "AdjustmentInProgress",
    CannotBePaidInPriorPeriods = "CannotBePaidInPriorPeriods",
}

export class FLSAPeriod implements IFLSAPeriod {
    flsaPeriodId?: number;
    companyId?: number;
    flsaWeekStart?: Date;
    flsaWeekEnd?: Date;
    payPeriodStart?: Date;
    payPeriodEnd?: Date;
    payDate?: Date;

    constructor(data?: IFLSAPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flsaPeriodId = _data["flsaPeriodId"];
            this.companyId = _data["companyId"];
            this.flsaWeekStart = _data["flsaWeekStart"] ? new Date(_data["flsaWeekStart"].toString()) : <any>undefined;
            this.flsaWeekEnd = _data["flsaWeekEnd"] ? new Date(_data["flsaWeekEnd"].toString()) : <any>undefined;
            this.payPeriodStart = _data["payPeriodStart"] ? new Date(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? new Date(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FLSAPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new FLSAPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flsaPeriodId"] = this.flsaPeriodId;
        data["companyId"] = this.companyId;
        data["flsaWeekStart"] = this.flsaWeekStart ? this.flsaWeekStart.toISOString() : <any>undefined;
        data["flsaWeekEnd"] = this.flsaWeekEnd ? this.flsaWeekEnd.toISOString() : <any>undefined;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toISOString() : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toISOString() : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFLSAPeriod {
    flsaPeriodId?: number;
    companyId?: number;
    flsaWeekStart?: Date;
    flsaWeekEnd?: Date;
    payPeriodStart?: Date;
    payPeriodEnd?: Date;
    payDate?: Date;
}

export enum FieldAttributes {
    PrivateScope = "PrivateScope",
    Private = "Private",
    FamANDAssem = "FamANDAssem",
    Assembly = "Assembly",
    Family = "Family",
    FamORAssem = "FamORAssem",
    Public = "Public",
    FieldAccessMask = "FieldAccessMask",
    Static = "Static",
    InitOnly = "InitOnly",
    Literal = "Literal",
    NotSerialized = "NotSerialized",
    HasFieldRVA = "HasFieldRVA",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
    HasFieldMarshal = "HasFieldMarshal",
    PinvokeImpl = "PinvokeImpl",
    HasDefault = "HasDefault",
    ReservedMask = "ReservedMask",
}

export class FieldInfo implements IFieldInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    readonly isInitOnly?: boolean;
    readonly isLiteral?: boolean;
    readonly isNotSerialized?: boolean;
    readonly isPinvokeImpl?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : <any>undefined;
            (<any>this).isInitOnly = _data["isInitOnly"];
            (<any>this).isLiteral = _data["isLiteral"];
            (<any>this).isNotSerialized = _data["isNotSerialized"];
            (<any>this).isPinvokeImpl = _data["isPinvokeImpl"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    isInitOnly?: boolean;
    isLiteral?: boolean;
    isNotSerialized?: boolean;
    isPinvokeImpl?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;
}

export class FileDto implements IFileDto {
    fileName?: string | undefined;
    content?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        return data;
    }
}

export interface IFileDto {
    fileName?: string | undefined;
    content?: string | undefined;
}

export class FilterRequest implements IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        return data;
    }
}

export interface IFilterRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
}

export enum GenericParameterAttributes {
    None = "None",
    Covariant = "Covariant",
    Contravariant = "Contravariant",
    VarianceMask = "VarianceMask",
    ReferenceTypeConstraint = "ReferenceTypeConstraint",
    NotNullableValueTypeConstraint = "NotNullableValueTypeConstraint",
    DefaultConstructorConstraint = "DefaultConstructorConstraint",
    SpecialConstraintMask = "SpecialConstraintMask",
}

export class GetLockedTcnsStatusRequest implements IGetLockedTcnsStatusRequest {
    tcn?: string[] | undefined;

    constructor(data?: IGetLockedTcnsStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcn"])) {
                this.tcn = [] as any;
                for (let item of _data["tcn"])
                    this.tcn!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLockedTcnsStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLockedTcnsStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcn)) {
            data["tcn"] = [];
            for (let item of this.tcn)
                data["tcn"].push(item);
        }
        return data;
    }
}

export interface IGetLockedTcnsStatusRequest {
    tcn?: string[] | undefined;
}

export class GetLockedTcnsStatusResponse implements IGetLockedTcnsStatusResponse {
    tcn?: string | undefined;
    isLocked?: string | undefined;

    constructor(data?: IGetLockedTcnsStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcn = _data["tcn"];
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): GetLockedTcnsStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLockedTcnsStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcn"] = this.tcn;
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IGetLockedTcnsStatusResponse {
    tcn?: string | undefined;
    isLocked?: string | undefined;
}

export class GetTcnsForPcnStatusRequest implements IGetTcnsForPcnStatusRequest {
    tcn?: string[] | undefined;

    constructor(data?: IGetTcnsForPcnStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcn"])) {
                this.tcn = [] as any;
                for (let item of _data["tcn"])
                    this.tcn!.push(item);
            }
        }
    }

    static fromJS(data: any): GetTcnsForPcnStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTcnsForPcnStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcn)) {
            data["tcn"] = [];
            for (let item of this.tcn)
                data["tcn"].push(item);
        }
        return data;
    }
}

export interface IGetTcnsForPcnStatusRequest {
    tcn?: string[] | undefined;
}

export class HolidayPayDateDto implements IHolidayPayDateDto {
    holidayPayDateId?: number | undefined;
    ecn?: string | undefined;
    description?: string | undefined;
    month?: string | undefined;
    day?: number;
    startDate?: Date;
    endDate?: Date;
    recurrence?: HolidayRecurrenceType;
    isActive?: boolean;
    maxHours?: number;
    multiplier?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean | undefined;
    recurrenceComboBox?: StringComboboxModel;

    constructor(data?: IHolidayPayDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayPayDateId = _data["holidayPayDateId"];
            this.ecn = _data["ecn"];
            this.description = _data["description"];
            this.month = _data["month"];
            this.day = _data["day"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recurrence = _data["recurrence"];
            this.isActive = _data["isActive"];
            this.maxHours = _data["maxHours"];
            this.multiplier = _data["multiplier"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.recurrenceComboBox = _data["recurrenceComboBox"] ? StringComboboxModel.fromJS(_data["recurrenceComboBox"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HolidayPayDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayPayDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayPayDateId"] = this.holidayPayDateId;
        data["ecn"] = this.ecn;
        data["description"] = this.description;
        data["month"] = this.month;
        data["day"] = this.day;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recurrence"] = this.recurrence;
        data["isActive"] = this.isActive;
        data["maxHours"] = this.maxHours;
        data["multiplier"] = this.multiplier;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["recurrenceComboBox"] = this.recurrenceComboBox ? this.recurrenceComboBox.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHolidayPayDateDto {
    holidayPayDateId?: number | undefined;
    ecn?: string | undefined;
    description?: string | undefined;
    month?: string | undefined;
    day?: number;
    startDate?: Date;
    endDate?: Date;
    recurrence?: HolidayRecurrenceType;
    isActive?: boolean;
    maxHours?: number;
    multiplier?: number;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
    isDeleted?: boolean | undefined;
    recurrenceComboBox?: StringComboboxModel;
}

export enum HolidayRecurrenceType {
    YEAR = "YEAR",
    ONE = "ONE",
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIActionResult {
}

export class IActionResultTask implements IIActionResultTask {
    readonly id?: number;
    exception?: AggregateException;
    status?: TaskStatus;
    readonly isCanceled?: boolean;
    readonly isCompleted?: boolean;
    readonly isCompletedSuccessfully?: boolean;
    creationOptions?: TaskCreationOptions;
    readonly asyncState?: any | undefined;
    readonly isFaulted?: boolean;
    result?: IActionResult;

    constructor(data?: IIActionResultTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.exception = _data["exception"] ? AggregateException.fromJS(_data["exception"]) : <any>undefined;
            this.status = _data["status"];
            (<any>this).isCanceled = _data["isCanceled"];
            (<any>this).isCompleted = _data["isCompleted"];
            (<any>this).isCompletedSuccessfully = _data["isCompletedSuccessfully"];
            this.creationOptions = _data["creationOptions"];
            (<any>this).asyncState = _data["asyncState"];
            (<any>this).isFaulted = _data["isFaulted"];
            this.result = _data["result"] ? IActionResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IActionResultTask {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResultTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["exception"] = this.exception ? this.exception.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["isCanceled"] = this.isCanceled;
        data["isCompleted"] = this.isCompleted;
        data["isCompletedSuccessfully"] = this.isCompletedSuccessfully;
        data["creationOptions"] = this.creationOptions;
        data["asyncState"] = this.asyncState;
        data["isFaulted"] = this.isFaulted;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIActionResultTask {
    id?: number;
    exception?: AggregateException;
    status?: TaskStatus;
    isCanceled?: boolean;
    isCompleted?: boolean;
    isCompletedSuccessfully?: boolean;
    creationOptions?: TaskCreationOptions;
    asyncState?: any | undefined;
    isFaulted?: boolean;
    result?: IActionResult;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class IdsRequest implements IIdsRequest {
    ids?: number[] | undefined;

    constructor(data?: IIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): IdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IIdsRequest {
    ids?: number[] | undefined;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {
}

export enum LayoutKind {
    Sequential = "Sequential",
    Explicit = "Explicit",
    Auto = "Auto",
}

export class MemberInfo implements IMemberInfo {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
}

export enum MemberTypes {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export enum MethodAttributes {
    PrivateScope = "PrivateScope",
    Private = "Private",
    FamANDAssem = "FamANDAssem",
    Assembly = "Assembly",
    Family = "Family",
    FamORAssem = "FamORAssem",
    Public = "Public",
    MemberAccessMask = "MemberAccessMask",
    UnmanagedExport = "UnmanagedExport",
    Static = "Static",
    Final = "Final",
    Virtual = "Virtual",
    HideBySig = "HideBySig",
    NewSlot = "NewSlot",
    CheckAccessOnOverride = "CheckAccessOnOverride",
    Abstract = "Abstract",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
    PinvokeImpl = "PinvokeImpl",
    HasSecurity = "HasSecurity",
    RequireSecObject = "RequireSecObject",
    ReservedMask = "ReservedMask",
}

export class MethodBase implements IMethodBase {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }
}

export interface IMethodBase {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

export enum MethodImplAttributes {
    IL = "IL",
    Native = "Native",
    OPTIL = "OPTIL",
    CodeTypeMask = "CodeTypeMask",
    ManagedMask = "ManagedMask",
    NoInlining = "NoInlining",
    ForwardRef = "ForwardRef",
    Synchronized = "Synchronized",
    NoOptimization = "NoOptimization",
    PreserveSig = "PreserveSig",
    AggressiveInlining = "AggressiveInlining",
    AggressiveOptimization = "AggressiveOptimization",
    InternalCall = "InternalCall",
    MaxMethodImplVal = "MaxMethodImplVal",
}

export class MethodInfo implements IMethodInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : <any>undefined;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMethodInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;
}

export class Module implements IModule {
    assembly?: Assembly;
    readonly fullyQualifiedName?: string | undefined;
    readonly name?: string | undefined;
    readonly mdStreamVersion?: number;
    readonly moduleVersionId?: string;
    readonly scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly?: Assembly;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion?: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number;
}

export class OvertimeCalculator implements IOvertimeCalculator {
    totalUnits?: number;
    totalDailyRegUnits?: number;
    totalDailyOtUnits?: number;
    totalFLSARegUnits?: number;
    totalFLSAOtUnits?: number;
    totalHolidayUnits?: number;
    flsaOtPerUnit?: number;
    isDailyOt?: boolean;
    overtimeRecords?: PCNRecord[] | undefined;
    readonly dayToDailyOtPerUnit?: { [key: string]: number; } | undefined;
    totalPay?: number;

    constructor(data?: IOvertimeCalculator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUnits = _data["totalUnits"];
            this.totalDailyRegUnits = _data["totalDailyRegUnits"];
            this.totalDailyOtUnits = _data["totalDailyOtUnits"];
            this.totalFLSARegUnits = _data["totalFLSARegUnits"];
            this.totalFLSAOtUnits = _data["totalFLSAOtUnits"];
            this.totalHolidayUnits = _data["totalHolidayUnits"];
            this.flsaOtPerUnit = _data["flsaOtPerUnit"];
            this.isDailyOt = _data["isDailyOt"];
            if (Array.isArray(_data["overtimeRecords"])) {
                this.overtimeRecords = [] as any;
                for (let item of _data["overtimeRecords"])
                    this.overtimeRecords!.push(PCNRecord.fromJS(item));
            }
            if (_data["dayToDailyOtPerUnit"]) {
                (<any>this).dayToDailyOtPerUnit = {} as any;
                for (let key in _data["dayToDailyOtPerUnit"]) {
                    if (_data["dayToDailyOtPerUnit"].hasOwnProperty(key))
                        (<any>(<any>this).dayToDailyOtPerUnit)![key] = _data["dayToDailyOtPerUnit"][key];
                }
            }
            this.totalPay = _data["totalPay"];
        }
    }

    static fromJS(data: any): OvertimeCalculator {
        data = typeof data === 'object' ? data : {};
        let result = new OvertimeCalculator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUnits"] = this.totalUnits;
        data["totalDailyRegUnits"] = this.totalDailyRegUnits;
        data["totalDailyOtUnits"] = this.totalDailyOtUnits;
        data["totalFLSARegUnits"] = this.totalFLSARegUnits;
        data["totalFLSAOtUnits"] = this.totalFLSAOtUnits;
        data["totalHolidayUnits"] = this.totalHolidayUnits;
        data["flsaOtPerUnit"] = this.flsaOtPerUnit;
        data["isDailyOt"] = this.isDailyOt;
        if (Array.isArray(this.overtimeRecords)) {
            data["overtimeRecords"] = [];
            for (let item of this.overtimeRecords)
                data["overtimeRecords"].push(item ? item.toJSON() : <any>undefined);
        }
        if (this.dayToDailyOtPerUnit) {
            data["dayToDailyOtPerUnit"] = {};
            for (let key in this.dayToDailyOtPerUnit) {
                if (this.dayToDailyOtPerUnit.hasOwnProperty(key))
                    (<any>data["dayToDailyOtPerUnit"])[key] = (<any>this.dayToDailyOtPerUnit)[key];
            }
        }
        data["totalPay"] = this.totalPay;
        return data;
    }
}

export interface IOvertimeCalculator {
    totalUnits?: number;
    totalDailyRegUnits?: number;
    totalDailyOtUnits?: number;
    totalFLSARegUnits?: number;
    totalFLSAOtUnits?: number;
    totalHolidayUnits?: number;
    flsaOtPerUnit?: number;
    isDailyOt?: boolean;
    overtimeRecords?: PCNRecord[] | undefined;
    dayToDailyOtPerUnit?: { [key: string]: number; } | undefined;
    totalPay?: number;
}

export class PCNRecord implements IPCNRecord {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    exclusion?: boolean;
    readonly exclude?: string | undefined;
    exclusionReason?: string | undefined;
    exclusionReasonEnumerated?: ExclusionReasons;
    id?: number;
    pcn?: string | undefined;
    tcn?: string | undefined;
    flsaWeekStart?: Date;
    flsaWeekEnd?: Date;
    effectiveFLSAWeekStart?: Date;
    effectiveFLSAWeekEnd?: Date;
    payDate?: Date;
    effectivePayDate?: Date;
    isLocked?: string | undefined;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;
    payrollProgramId?: string | undefined;
    participantId?: string | undefined;
    caregiverEmployerMappingId?: number;
    evaluationDate?: Date | undefined;
    docType?: string | undefined;
    is20147?: boolean;
    isFICA?: boolean;
    isFICAChild?: boolean;
    isHoliday?: boolean;
    isOvertimeEligible?: boolean;
    isPSST?: boolean;
    servCode?: string | undefined;
    calculatedAmount?: number;
    calHrs?: number;
    payRate?: number;
    subPayRate?: number | undefined;
    payUnits?: number;
    subPayUnits?: number | undefined;
    holidayPayUnits?: number | undefined;
    holidaySubPayUnits?: number | undefined;
    companyId?: number;
    earningType?: string | undefined;
    serviceDate?: Date;
    status?: PcnStatus;
    readonly statusText?: string | undefined;
    isSentTime?: boolean;
    readonly isInProgress?: boolean;
    readonly isLateTime?: boolean;
    overtimeCalculator?: OvertimeCalculator;
    readonly overtimePerUnit?: number;
    isAbsence?: boolean | undefined;
    isPositive?: boolean;
    isPayRateOverride?: boolean;
    payCalcMethod?: PayCalcMethod;
    isCchSplit?: boolean;
    isAdjusted?: boolean;
    ecn?: string | undefined;
    payorCode?: string | undefined;
    worktag?: string | undefined;

    constructor(data?: IPCNRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.exclusion = _data["exclusion"];
            (<any>this).exclude = _data["exclude"];
            this.exclusionReason = _data["exclusionReason"];
            this.exclusionReasonEnumerated = _data["exclusionReasonEnumerated"];
            this.id = _data["id"];
            this.pcn = _data["pcn"];
            this.tcn = _data["tcn"];
            this.flsaWeekStart = _data["flsaWeekStart"] ? new Date(_data["flsaWeekStart"].toString()) : <any>undefined;
            this.flsaWeekEnd = _data["flsaWeekEnd"] ? new Date(_data["flsaWeekEnd"].toString()) : <any>undefined;
            this.effectiveFLSAWeekStart = _data["effectiveFLSAWeekStart"] ? new Date(_data["effectiveFLSAWeekStart"].toString()) : <any>undefined;
            this.effectiveFLSAWeekEnd = _data["effectiveFLSAWeekEnd"] ? new Date(_data["effectiveFLSAWeekEnd"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.effectivePayDate = _data["effectivePayDate"] ? new Date(_data["effectivePayDate"].toString()) : <any>undefined;
            this.isLocked = _data["isLocked"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverName = _data["caregiverName"];
            this.payrollProgramId = _data["payrollProgramId"];
            this.participantId = _data["participantId"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.evaluationDate = _data["evaluationDate"] ? new Date(_data["evaluationDate"].toString()) : <any>undefined;
            this.docType = _data["docType"];
            this.is20147 = _data["is20147"];
            this.isFICA = _data["isFICA"];
            this.isFICAChild = _data["isFICAChild"];
            this.isHoliday = _data["isHoliday"];
            this.isOvertimeEligible = _data["isOvertimeEligible"];
            this.isPSST = _data["isPSST"];
            this.servCode = _data["servCode"];
            this.calculatedAmount = _data["calculatedAmount"];
            this.calHrs = _data["calHrs"];
            this.payRate = _data["payRate"];
            this.subPayRate = _data["subPayRate"];
            this.payUnits = _data["payUnits"];
            this.subPayUnits = _data["subPayUnits"];
            this.holidayPayUnits = _data["holidayPayUnits"];
            this.holidaySubPayUnits = _data["holidaySubPayUnits"];
            this.companyId = _data["companyId"];
            this.earningType = _data["earningType"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            (<any>this).statusText = _data["statusText"];
            this.isSentTime = _data["isSentTime"];
            (<any>this).isInProgress = _data["isInProgress"];
            (<any>this).isLateTime = _data["isLateTime"];
            this.overtimeCalculator = _data["overtimeCalculator"] ? OvertimeCalculator.fromJS(_data["overtimeCalculator"]) : <any>undefined;
            (<any>this).overtimePerUnit = _data["overtimePerUnit"];
            this.isAbsence = _data["isAbsence"];
            this.isPositive = _data["isPositive"];
            this.isPayRateOverride = _data["isPayRateOverride"];
            this.payCalcMethod = _data["payCalcMethod"];
            this.isCchSplit = _data["isCchSplit"];
            this.isAdjusted = _data["isAdjusted"];
            this.ecn = _data["ecn"];
            this.payorCode = _data["payorCode"];
            this.worktag = _data["worktag"];
        }
    }

    static fromJS(data: any): PCNRecord {
        data = typeof data === 'object' ? data : {};
        let result = new PCNRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["exclusion"] = this.exclusion;
        data["exclude"] = this.exclude;
        data["exclusionReason"] = this.exclusionReason;
        data["exclusionReasonEnumerated"] = this.exclusionReasonEnumerated;
        data["id"] = this.id;
        data["pcn"] = this.pcn;
        data["tcn"] = this.tcn;
        data["flsaWeekStart"] = this.flsaWeekStart ? this.flsaWeekStart.toISOString() : <any>undefined;
        data["flsaWeekEnd"] = this.flsaWeekEnd ? this.flsaWeekEnd.toISOString() : <any>undefined;
        data["effectiveFLSAWeekStart"] = this.effectiveFLSAWeekStart ? this.effectiveFLSAWeekStart.toISOString() : <any>undefined;
        data["effectiveFLSAWeekEnd"] = this.effectiveFLSAWeekEnd ? this.effectiveFLSAWeekEnd.toISOString() : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["effectivePayDate"] = this.effectivePayDate ? this.effectivePayDate.toISOString() : <any>undefined;
        data["isLocked"] = this.isLocked;
        data["caregiverId"] = this.caregiverId;
        data["caregiverName"] = this.caregiverName;
        data["payrollProgramId"] = this.payrollProgramId;
        data["participantId"] = this.participantId;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        data["docType"] = this.docType;
        data["is20147"] = this.is20147;
        data["isFICA"] = this.isFICA;
        data["isFICAChild"] = this.isFICAChild;
        data["isHoliday"] = this.isHoliday;
        data["isOvertimeEligible"] = this.isOvertimeEligible;
        data["isPSST"] = this.isPSST;
        data["servCode"] = this.servCode;
        data["calculatedAmount"] = this.calculatedAmount;
        data["calHrs"] = this.calHrs;
        data["payRate"] = this.payRate;
        data["subPayRate"] = this.subPayRate;
        data["payUnits"] = this.payUnits;
        data["subPayUnits"] = this.subPayUnits;
        data["holidayPayUnits"] = this.holidayPayUnits;
        data["holidaySubPayUnits"] = this.holidaySubPayUnits;
        data["companyId"] = this.companyId;
        data["earningType"] = this.earningType;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["isSentTime"] = this.isSentTime;
        data["isInProgress"] = this.isInProgress;
        data["isLateTime"] = this.isLateTime;
        data["overtimeCalculator"] = this.overtimeCalculator ? this.overtimeCalculator.toJSON() : <any>undefined;
        data["overtimePerUnit"] = this.overtimePerUnit;
        data["isAbsence"] = this.isAbsence;
        data["isPositive"] = this.isPositive;
        data["isPayRateOverride"] = this.isPayRateOverride;
        data["payCalcMethod"] = this.payCalcMethod;
        data["isCchSplit"] = this.isCchSplit;
        data["isAdjusted"] = this.isAdjusted;
        data["ecn"] = this.ecn;
        data["payorCode"] = this.payorCode;
        data["worktag"] = this.worktag;
        return data;
    }
}

export interface IPCNRecord {
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    exclusion?: boolean;
    exclude?: string | undefined;
    exclusionReason?: string | undefined;
    exclusionReasonEnumerated?: ExclusionReasons;
    id?: number;
    pcn?: string | undefined;
    tcn?: string | undefined;
    flsaWeekStart?: Date;
    flsaWeekEnd?: Date;
    effectiveFLSAWeekStart?: Date;
    effectiveFLSAWeekEnd?: Date;
    payDate?: Date;
    effectivePayDate?: Date;
    isLocked?: string | undefined;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;
    payrollProgramId?: string | undefined;
    participantId?: string | undefined;
    caregiverEmployerMappingId?: number;
    evaluationDate?: Date | undefined;
    docType?: string | undefined;
    is20147?: boolean;
    isFICA?: boolean;
    isFICAChild?: boolean;
    isHoliday?: boolean;
    isOvertimeEligible?: boolean;
    isPSST?: boolean;
    servCode?: string | undefined;
    calculatedAmount?: number;
    calHrs?: number;
    payRate?: number;
    subPayRate?: number | undefined;
    payUnits?: number;
    subPayUnits?: number | undefined;
    holidayPayUnits?: number | undefined;
    holidaySubPayUnits?: number | undefined;
    companyId?: number;
    earningType?: string | undefined;
    serviceDate?: Date;
    status?: PcnStatus;
    statusText?: string | undefined;
    isSentTime?: boolean;
    isInProgress?: boolean;
    isLateTime?: boolean;
    overtimeCalculator?: OvertimeCalculator;
    overtimePerUnit?: number;
    isAbsence?: boolean | undefined;
    isPositive?: boolean;
    isPayRateOverride?: boolean;
    payCalcMethod?: PayCalcMethod;
    isCchSplit?: boolean;
    isAdjusted?: boolean;
    ecn?: string | undefined;
    payorCode?: string | undefined;
    worktag?: string | undefined;
}

export class PCNRecordGridResponseBase implements IPCNRecordGridResponseBase {
    items?: PCNRecord[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PCNRecord;

    constructor(data?: IPCNRecordGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PCNRecord.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PCNRecord.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PCNRecordGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PCNRecordGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPCNRecordGridResponseBase {
    items?: PCNRecord[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PCNRecord;
}

export enum ParameterAttributes {
    None = "None",
    In = "In",
    Out = "Out",
    Lcid = "Lcid",
    Retval = "Retval",
    Optional = "Optional",
    HasDefault = "HasDefault",
    HasFieldMarshal = "HasFieldMarshal",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export class ParameterInfo implements IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    readonly name?: string | undefined;
    parameterType?: Type;
    readonly position?: number;
    readonly isIn?: boolean;
    readonly isLcid?: boolean;
    readonly isOptional?: boolean;
    readonly isOut?: boolean;
    readonly isRetval?: boolean;
    readonly defaultValue?: any | undefined;
    readonly rawDefaultValue?: any | undefined;
    readonly hasDefaultValue?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : <any>undefined;
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: Type;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export class ParticipantCaregiverEmployerPayRateData implements IParticipantCaregiverEmployerPayRateData {
    id?: number | undefined;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    dateBegin?: Date;
    dateEnd?: Date;
    timeBegin?: Date;
    timeEnd?: Date;
    validDays?: string | undefined;
    participantId?: number;
    caregiverId?: number;
    caregiverEmployerMappingId?: number;
    earnType?: string | undefined;
    payRate?: number;
    holidayPremium?: number | undefined;
    isOvertimeEligible?: boolean;
    isActive?: boolean;
    comment?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;

    constructor(data?: IParticipantCaregiverEmployerPayRateData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceCodeId = _data["serviceCodeId"];
            this.serviceCode = _data["serviceCode"];
            this.dateBegin = _data["dateBegin"] ? new Date(_data["dateBegin"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.timeBegin = _data["timeBegin"] ? new Date(_data["timeBegin"].toString()) : <any>undefined;
            this.timeEnd = _data["timeEnd"] ? new Date(_data["timeEnd"].toString()) : <any>undefined;
            this.validDays = _data["validDays"];
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.earnType = _data["earnType"];
            this.payRate = _data["payRate"];
            this.holidayPremium = _data["holidayPremium"];
            this.isOvertimeEligible = _data["isOvertimeEligible"];
            this.isActive = _data["isActive"];
            this.comment = _data["comment"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverEmployerPayRateData {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverEmployerPayRateData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceCodeId"] = this.serviceCodeId;
        data["serviceCode"] = this.serviceCode;
        data["dateBegin"] = this.dateBegin ? this.dateBegin.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["timeBegin"] = this.timeBegin ? this.timeBegin.toISOString() : <any>undefined;
        data["timeEnd"] = this.timeEnd ? this.timeEnd.toISOString() : <any>undefined;
        data["validDays"] = this.validDays;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["earnType"] = this.earnType;
        data["payRate"] = this.payRate;
        data["holidayPremium"] = this.holidayPremium;
        data["isOvertimeEligible"] = this.isOvertimeEligible;
        data["isActive"] = this.isActive;
        data["comment"] = this.comment;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverEmployerPayRateData {
    id?: number | undefined;
    serviceCodeId?: number;
    serviceCode?: string | undefined;
    dateBegin?: Date;
    dateEnd?: Date;
    timeBegin?: Date;
    timeEnd?: Date;
    validDays?: string | undefined;
    participantId?: number;
    caregiverId?: number;
    caregiverEmployerMappingId?: number;
    earnType?: string | undefined;
    payRate?: number;
    holidayPremium?: number | undefined;
    isOvertimeEligible?: boolean;
    isActive?: boolean;
    comment?: string | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date;
}

export class ParticipantCaregiverEmployerPayRateDataGridResponseBase implements IParticipantCaregiverEmployerPayRateDataGridResponseBase {
    items?: ParticipantCaregiverEmployerPayRateData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ParticipantCaregiverEmployerPayRateData;

    constructor(data?: IParticipantCaregiverEmployerPayRateDataGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParticipantCaregiverEmployerPayRateData.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? ParticipantCaregiverEmployerPayRateData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParticipantCaregiverEmployerPayRateDataGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantCaregiverEmployerPayRateDataGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParticipantCaregiverEmployerPayRateDataGridResponseBase {
    items?: ParticipantCaregiverEmployerPayRateData[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: ParticipantCaregiverEmployerPayRateData;
}

export enum PayCalcMethod {
    EMPE = "EMPE",
    NONE = "NONE",
    CH = "CH",
    EMPR = "EMPR",
}

export class PayPeriod implements IPayPeriod {
    payPeriodStart?: Date | undefined;
    payPeriodEnd?: Date | undefined;

    constructor(data?: IPayPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payPeriodStart = _data["payPeriodStart"] ? new Date(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? new Date(_data["payPeriodEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new PayPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toISOString() : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayPeriod {
    payPeriodStart?: Date | undefined;
    payPeriodEnd?: Date | undefined;
}

export class PayRateHistoryRequest implements IPayRateHistoryRequest {
    caregiverParticipantMappingIds?: number[] | undefined;

    constructor(data?: IPayRateHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caregiverParticipantMappingIds"])) {
                this.caregiverParticipantMappingIds = [] as any;
                for (let item of _data["caregiverParticipantMappingIds"])
                    this.caregiverParticipantMappingIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PayRateHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caregiverParticipantMappingIds)) {
            data["caregiverParticipantMappingIds"] = [];
            for (let item of this.caregiverParticipantMappingIds)
                data["caregiverParticipantMappingIds"].push(item);
        }
        return data;
    }
}

export interface IPayRateHistoryRequest {
    caregiverParticipantMappingIds?: number[] | undefined;
}

export class PayRateRequest implements IPayRateRequest {
    caregiverId?: string | undefined;
    ecn?: string | undefined;
    employerId?: number | undefined;
    participantId?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    isPositive?: boolean;
    overrideCareerHours?: number | undefined;

    constructor(data?: IPayRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            this.ecn = _data["ecn"];
            this.employerId = _data["employerId"];
            this.participantId = _data["participantId"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.isPositive = _data["isPositive"];
            this.overrideCareerHours = _data["overrideCareerHours"];
        }
    }

    static fromJS(data: any): PayRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        data["ecn"] = this.ecn;
        data["employerId"] = this.employerId;
        data["participantId"] = this.participantId;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["isPositive"] = this.isPositive;
        data["overrideCareerHours"] = this.overrideCareerHours;
        return data;
    }
}

export interface IPayRateRequest {
    caregiverId?: string | undefined;
    ecn?: string | undefined;
    employerId?: number | undefined;
    participantId?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    isPositive?: boolean;
    overrideCareerHours?: number | undefined;
}

export class PayRateResponse implements IPayRateResponse {
    payRates?: number[] | undefined;
    isHoliday?: boolean | undefined;
    payCalcMethod?: string | undefined;
    otFlag?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IPayRateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payRates"])) {
                this.payRates = [] as any;
                for (let item of _data["payRates"])
                    this.payRates!.push(item);
            }
            this.isHoliday = _data["isHoliday"];
            this.payCalcMethod = _data["payCalcMethod"];
            this.otFlag = _data["otFlag"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payRates)) {
            data["payRates"] = [];
            for (let item of this.payRates)
                data["payRates"].push(item);
        }
        data["isHoliday"] = this.isHoliday;
        data["payCalcMethod"] = this.payCalcMethod;
        data["otFlag"] = this.otFlag;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayRateResponse {
    payRates?: number[] | undefined;
    isHoliday?: boolean | undefined;
    payCalcMethod?: string | undefined;
    otFlag?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class PayRateResponseBulk implements IPayRateResponseBulk {
    payRates?: number[] | undefined;
    isHoliday?: boolean | undefined;
    payCalcMethod?: string | undefined;
    otFlag?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    caregiverId?: string | undefined;
    ecn?: string | undefined;
    participantId?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;

    constructor(data?: IPayRateResponseBulk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payRates"])) {
                this.payRates = [] as any;
                for (let item of _data["payRates"])
                    this.payRates!.push(item);
            }
            this.isHoliday = _data["isHoliday"];
            this.payCalcMethod = _data["payCalcMethod"];
            this.otFlag = _data["otFlag"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.caregiverId = _data["caregiverId"];
            this.ecn = _data["ecn"];
            this.participantId = _data["participantId"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayRateResponseBulk {
        data = typeof data === 'object' ? data : {};
        let result = new PayRateResponseBulk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payRates)) {
            data["payRates"] = [];
            for (let item of this.payRates)
                data["payRates"].push(item);
        }
        data["isHoliday"] = this.isHoliday;
        data["payCalcMethod"] = this.payCalcMethod;
        data["otFlag"] = this.otFlag;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["caregiverId"] = this.caregiverId;
        data["ecn"] = this.ecn;
        data["participantId"] = this.participantId;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayRateResponseBulk {
    payRates?: number[] | undefined;
    isHoliday?: boolean | undefined;
    payCalcMethod?: string | undefined;
    otFlag?: boolean;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    caregiverId?: string | undefined;
    ecn?: string | undefined;
    participantId?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
}

export enum PayRateType {
    Employer = "Employer",
    ParticipantCaregiverEmployer = "ParticipantCaregiverEmployer",
    CalculatedCareerHour = "CalculatedCareerHour",
}

export class PayrollAggregateDetails implements IPayrollAggregateDetails {
    payrollOutputId?: number;
    workdayEmployeeId?: string | undefined;
    orgWorktag?: string | undefined;
    payrollBatchId?: number;
    earningCode?: string | undefined;
    effectiveEarningCode?: string | undefined;
    payUnits?: number;
    relatedCalc1?: string | undefined;
    payRate?: number;
    relatedCalc2?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    effectiveStartDate?: Date;
    effectiveEndDate?: Date;
    payDate?: Date;
    effectivePayDate?: Date;
    companyCode?: string | undefined;
    payrollRunId?: string | undefined;
    isPSST?: boolean;
    correlationId?: string;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;

    constructor(data?: IPayrollAggregateDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollOutputId = _data["payrollOutputId"];
            this.workdayEmployeeId = _data["workdayEmployeeId"];
            this.orgWorktag = _data["orgWorktag"];
            this.payrollBatchId = _data["payrollBatchId"];
            this.earningCode = _data["earningCode"];
            this.effectiveEarningCode = _data["effectiveEarningCode"];
            this.payUnits = _data["payUnits"];
            this.relatedCalc1 = _data["relatedCalc1"];
            this.payRate = _data["payRate"];
            this.relatedCalc2 = _data["relatedCalc2"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.effectiveStartDate = _data["effectiveStartDate"] ? new Date(_data["effectiveStartDate"].toString()) : <any>undefined;
            this.effectiveEndDate = _data["effectiveEndDate"] ? new Date(_data["effectiveEndDate"].toString()) : <any>undefined;
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.effectivePayDate = _data["effectivePayDate"] ? new Date(_data["effectivePayDate"].toString()) : <any>undefined;
            this.companyCode = _data["companyCode"];
            this.payrollRunId = _data["payrollRunId"];
            this.isPSST = _data["isPSST"];
            this.correlationId = _data["correlationId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverName = _data["caregiverName"];
        }
    }

    static fromJS(data: any): PayrollAggregateDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollAggregateDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollOutputId"] = this.payrollOutputId;
        data["workdayEmployeeId"] = this.workdayEmployeeId;
        data["orgWorktag"] = this.orgWorktag;
        data["payrollBatchId"] = this.payrollBatchId;
        data["earningCode"] = this.earningCode;
        data["effectiveEarningCode"] = this.effectiveEarningCode;
        data["payUnits"] = this.payUnits;
        data["relatedCalc1"] = this.relatedCalc1;
        data["payRate"] = this.payRate;
        data["relatedCalc2"] = this.relatedCalc2;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["effectiveStartDate"] = this.effectiveStartDate ? this.effectiveStartDate.toISOString() : <any>undefined;
        data["effectiveEndDate"] = this.effectiveEndDate ? this.effectiveEndDate.toISOString() : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["effectivePayDate"] = this.effectivePayDate ? this.effectivePayDate.toISOString() : <any>undefined;
        data["companyCode"] = this.companyCode;
        data["payrollRunId"] = this.payrollRunId;
        data["isPSST"] = this.isPSST;
        data["correlationId"] = this.correlationId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverName"] = this.caregiverName;
        return data;
    }
}

export interface IPayrollAggregateDetails {
    payrollOutputId?: number;
    workdayEmployeeId?: string | undefined;
    orgWorktag?: string | undefined;
    payrollBatchId?: number;
    earningCode?: string | undefined;
    effectiveEarningCode?: string | undefined;
    payUnits?: number;
    relatedCalc1?: string | undefined;
    payRate?: number;
    relatedCalc2?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    effectiveStartDate?: Date;
    effectiveEndDate?: Date;
    payDate?: Date;
    effectivePayDate?: Date;
    companyCode?: string | undefined;
    payrollRunId?: string | undefined;
    isPSST?: boolean;
    correlationId?: string;
    caregiverId?: string | undefined;
    caregiverName?: string | undefined;
}

export class PayrollAggregateDetailsGridResponseBase implements IPayrollAggregateDetailsGridResponseBase {
    items?: PayrollAggregateDetails[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollAggregateDetails;

    constructor(data?: IPayrollAggregateDetailsGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayrollAggregateDetails.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PayrollAggregateDetails.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollAggregateDetailsGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollAggregateDetailsGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayrollAggregateDetailsGridResponseBase {
    items?: PayrollAggregateDetails[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollAggregateDetails;
}

export class PayrollBatchPreviewResponse implements IPayrollBatchPreviewResponse {
    pcnRecords?: PCNRecordGridResponseBase;
    batchSummary?: BatchSummary;
    workdayLatePayCutoff?: Date | undefined;

    constructor(data?: IPayrollBatchPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pcnRecords = _data["pcnRecords"] ? PCNRecordGridResponseBase.fromJS(_data["pcnRecords"]) : <any>undefined;
            this.batchSummary = _data["batchSummary"] ? BatchSummary.fromJS(_data["batchSummary"]) : <any>undefined;
            this.workdayLatePayCutoff = _data["workdayLatePayCutoff"] ? new Date(_data["workdayLatePayCutoff"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollBatchPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollBatchPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pcnRecords"] = this.pcnRecords ? this.pcnRecords.toJSON() : <any>undefined;
        data["batchSummary"] = this.batchSummary ? this.batchSummary.toJSON() : <any>undefined;
        data["workdayLatePayCutoff"] = this.workdayLatePayCutoff ? this.workdayLatePayCutoff.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayrollBatchPreviewResponse {
    pcnRecords?: PCNRecordGridResponseBase;
    batchSummary?: BatchSummary;
    workdayLatePayCutoff?: Date | undefined;
}

export class PayrollConfigDetails implements IPayrollConfigDetails {
    payrollSystem?: string | undefined;
    serviceCode?: string | undefined;
    earningType?: string | undefined;
    isAbsence?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    defaultExclusionCriteria?: string[] | undefined;

    constructor(data?: IPayrollConfigDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollSystem = _data["payrollSystem"];
            this.serviceCode = _data["serviceCode"];
            this.earningType = _data["earningType"];
            this.isAbsence = _data["isAbsence"];
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["defaultExclusionCriteria"])) {
                this.defaultExclusionCriteria = [] as any;
                for (let item of _data["defaultExclusionCriteria"])
                    this.defaultExclusionCriteria!.push(item);
            }
        }
    }

    static fromJS(data: any): PayrollConfigDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollConfigDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollSystem"] = this.payrollSystem;
        data["serviceCode"] = this.serviceCode;
        data["earningType"] = this.earningType;
        data["isAbsence"] = this.isAbsence;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.defaultExclusionCriteria)) {
            data["defaultExclusionCriteria"] = [];
            for (let item of this.defaultExclusionCriteria)
                data["defaultExclusionCriteria"].push(item);
        }
        return data;
    }
}

export interface IPayrollConfigDetails {
    payrollSystem?: string | undefined;
    serviceCode?: string | undefined;
    earningType?: string | undefined;
    isAbsence?: boolean;
    updatedBy?: string | undefined;
    updatedOn?: Date;
    defaultExclusionCriteria?: string[] | undefined;
}

export class PayrollConfigEarn implements IPayrollConfigEarn {
    earningCategoryId?: number;
    earningCategoryCode?: string | undefined;

    constructor(data?: IPayrollConfigEarn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.earningCategoryId = _data["earningCategoryId"];
            this.earningCategoryCode = _data["earningCategoryCode"];
        }
    }

    static fromJS(data: any): PayrollConfigEarn {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollConfigEarn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["earningCategoryId"] = this.earningCategoryId;
        data["earningCategoryCode"] = this.earningCategoryCode;
        return data;
    }
}

export interface IPayrollConfigEarn {
    earningCategoryId?: number;
    earningCategoryCode?: string | undefined;
}

export class PayrollConfigServe implements IPayrollConfigServe {
    servCodeEarningTypeId?: number;
    serviceCode?: string | undefined;
    is20147?: boolean;
    isFICA?: boolean;

    constructor(data?: IPayrollConfigServe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCodeEarningTypeId = _data["servCodeEarningTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.is20147 = _data["is20147"];
            this.isFICA = _data["isFICA"];
        }
    }

    static fromJS(data: any): PayrollConfigServe {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollConfigServe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCodeEarningTypeId"] = this.servCodeEarningTypeId;
        data["serviceCode"] = this.serviceCode;
        data["is20147"] = this.is20147;
        data["isFICA"] = this.isFICA;
        return data;
    }
}

export interface IPayrollConfigServe {
    servCodeEarningTypeId?: number;
    serviceCode?: string | undefined;
    is20147?: boolean;
    isFICA?: boolean;
}

export class PayrollDetailsRequest implements IPayrollDetailsRequest {
    companyCode?: string | undefined;
    tcnIds?: string[] | undefined;

    constructor(data?: IPayrollDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            if (Array.isArray(_data["tcnIds"])) {
                this.tcnIds = [] as any;
                for (let item of _data["tcnIds"])
                    this.tcnIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PayrollDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        if (Array.isArray(this.tcnIds)) {
            data["tcnIds"] = [];
            for (let item of this.tcnIds)
                data["tcnIds"].push(item);
        }
        return data;
    }
}

export interface IPayrollDetailsRequest {
    companyCode?: string | undefined;
    tcnIds?: string[] | undefined;
}

export class PayrollLockTcnStatus implements IPayrollLockTcnStatus {
    tcns?: string[] | undefined;
    response?: Response;

    constructor(data?: IPayrollLockTcnStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcns"])) {
                this.tcns = [] as any;
                for (let item of _data["tcns"])
                    this.tcns!.push(item);
            }
            this.response = _data["response"] ? Response.fromJS(_data["response"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollLockTcnStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollLockTcnStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcns)) {
            data["tcns"] = [];
            for (let item of this.tcns)
                data["tcns"].push(item);
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayrollLockTcnStatus {
    tcns?: string[] | undefined;
    response?: Response;
}

export class PayrollMassRecordUpdateExclusionRequest implements IPayrollMassRecordUpdateExclusionRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    docType?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    startFlsaDate?: Date | undefined;
    endFlsaDate?: Date | undefined;
    startPayPeriodDate?: Date | undefined;
    endPayPeriodDate?: Date | undefined;
    payrollExternalId?: string | undefined;
    isolationId?: string | undefined;
    userMail?: string | undefined;
    caregiverId?: number | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    companyId?: number | undefined;
    companyCode?: string | undefined;
    serviceCodes?: string[] | undefined;
    employeeIds?: string[] | undefined;
    excludeRecords?: boolean;
    reincludeRecords?: boolean;
    exclusionReason?: string | undefined;

    constructor(data?: IPayrollMassRecordUpdateExclusionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            if (Array.isArray(_data["docType"])) {
                this.docType = [] as any;
                for (let item of _data["docType"])
                    this.docType!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.startFlsaDate = _data["startFlsaDate"] ? new Date(_data["startFlsaDate"].toString()) : <any>undefined;
            this.endFlsaDate = _data["endFlsaDate"] ? new Date(_data["endFlsaDate"].toString()) : <any>undefined;
            this.startPayPeriodDate = _data["startPayPeriodDate"] ? new Date(_data["startPayPeriodDate"].toString()) : <any>undefined;
            this.endPayPeriodDate = _data["endPayPeriodDate"] ? new Date(_data["endPayPeriodDate"].toString()) : <any>undefined;
            this.payrollExternalId = _data["payrollExternalId"];
            this.isolationId = _data["isolationId"];
            this.userMail = _data["userMail"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            if (Array.isArray(_data["serviceCodes"])) {
                this.serviceCodes = [] as any;
                for (let item of _data["serviceCodes"])
                    this.serviceCodes!.push(item);
            }
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            this.excludeRecords = _data["excludeRecords"];
            this.reincludeRecords = _data["reincludeRecords"];
            this.exclusionReason = _data["exclusionReason"];
        }
    }

    static fromJS(data: any): PayrollMassRecordUpdateExclusionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollMassRecordUpdateExclusionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        if (Array.isArray(this.docType)) {
            data["docType"] = [];
            for (let item of this.docType)
                data["docType"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["startFlsaDate"] = this.startFlsaDate ? this.startFlsaDate.toISOString() : <any>undefined;
        data["endFlsaDate"] = this.endFlsaDate ? this.endFlsaDate.toISOString() : <any>undefined;
        data["startPayPeriodDate"] = this.startPayPeriodDate ? this.startPayPeriodDate.toISOString() : <any>undefined;
        data["endPayPeriodDate"] = this.endPayPeriodDate ? this.endPayPeriodDate.toISOString() : <any>undefined;
        data["payrollExternalId"] = this.payrollExternalId;
        data["isolationId"] = this.isolationId;
        data["userMail"] = this.userMail;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        if (Array.isArray(this.serviceCodes)) {
            data["serviceCodes"] = [];
            for (let item of this.serviceCodes)
                data["serviceCodes"].push(item);
        }
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        data["excludeRecords"] = this.excludeRecords;
        data["reincludeRecords"] = this.reincludeRecords;
        data["exclusionReason"] = this.exclusionReason;
        return data;
    }
}

export interface IPayrollMassRecordUpdateExclusionRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    docType?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    startFlsaDate?: Date | undefined;
    endFlsaDate?: Date | undefined;
    startPayPeriodDate?: Date | undefined;
    endPayPeriodDate?: Date | undefined;
    payrollExternalId?: string | undefined;
    isolationId?: string | undefined;
    userMail?: string | undefined;
    caregiverId?: number | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    companyId?: number | undefined;
    companyCode?: string | undefined;
    serviceCodes?: string[] | undefined;
    employeeIds?: string[] | undefined;
    excludeRecords?: boolean;
    reincludeRecords?: boolean;
    exclusionReason?: string | undefined;
}

export class PayrollRecordDetails implements IPayrollRecordDetails {
    id?: number;
    pcn?: string | undefined;
    refPCN?: string | undefined;
    tcn?: string | undefined;
    prbcnId?: number | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    payorCode?: string | undefined;
    status?: number;
    readonly statusText?: string | undefined;
    payDate?: Date | undefined;
    receivedDate?: Date | undefined;
    totalPayAmount?: number | undefined;
    calculatedAmount?: number | undefined;
    unitsReg?: number | undefined;
    payRate?: number | undefined;
    taxTotal?: number | undefined;
    serviceDate?: Date | undefined;
    servCode?: string | undefined;
    checkNbr?: string | undefined;
    checkdate?: Date | undefined;
    calHrs?: number | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    companyId?: number | undefined;
    isAdjusted?: boolean | undefined;
    pcnSubStatus?: number;
    readonly pcnSubStatusText?: string | undefined;
    payReg?: number;
    isPositive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;

    constructor(data?: IPayrollRecordDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pcn = _data["pcn"];
            this.refPCN = _data["refPCN"];
            this.tcn = _data["tcn"];
            this.prbcnId = _data["prbcnId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.payorCode = _data["payorCode"];
            this.status = _data["status"];
            (<any>this).statusText = _data["statusText"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.totalPayAmount = _data["totalPayAmount"];
            this.calculatedAmount = _data["calculatedAmount"];
            this.unitsReg = _data["unitsReg"];
            this.payRate = _data["payRate"];
            this.taxTotal = _data["taxTotal"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.servCode = _data["servCode"];
            this.checkNbr = _data["checkNbr"];
            this.checkdate = _data["checkdate"] ? new Date(_data["checkdate"].toString()) : <any>undefined;
            this.calHrs = _data["calHrs"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.companyId = _data["companyId"];
            this.isAdjusted = _data["isAdjusted"];
            this.pcnSubStatus = _data["pcnSubStatus"];
            (<any>this).pcnSubStatusText = _data["pcnSubStatusText"];
            this.payReg = _data["payReg"];
            this.isPositive = _data["isPositive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollRecordDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRecordDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pcn"] = this.pcn;
        data["refPCN"] = this.refPCN;
        data["tcn"] = this.tcn;
        data["prbcnId"] = this.prbcnId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["payorCode"] = this.payorCode;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["totalPayAmount"] = this.totalPayAmount;
        data["calculatedAmount"] = this.calculatedAmount;
        data["unitsReg"] = this.unitsReg;
        data["payRate"] = this.payRate;
        data["taxTotal"] = this.taxTotal;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["servCode"] = this.servCode;
        data["checkNbr"] = this.checkNbr;
        data["checkdate"] = this.checkdate ? this.checkdate.toISOString() : <any>undefined;
        data["calHrs"] = this.calHrs;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["companyId"] = this.companyId;
        data["isAdjusted"] = this.isAdjusted;
        data["pcnSubStatus"] = this.pcnSubStatus;
        data["pcnSubStatusText"] = this.pcnSubStatusText;
        data["payReg"] = this.payReg;
        data["isPositive"] = this.isPositive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayrollRecordDetails {
    id?: number;
    pcn?: string | undefined;
    refPCN?: string | undefined;
    tcn?: string | undefined;
    prbcnId?: number | undefined;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    payorCode?: string | undefined;
    status?: number;
    statusText?: string | undefined;
    payDate?: Date | undefined;
    receivedDate?: Date | undefined;
    totalPayAmount?: number | undefined;
    calculatedAmount?: number | undefined;
    unitsReg?: number | undefined;
    payRate?: number | undefined;
    taxTotal?: number | undefined;
    serviceDate?: Date | undefined;
    servCode?: string | undefined;
    checkNbr?: string | undefined;
    checkdate?: Date | undefined;
    calHrs?: number | undefined;
    inTime?: Date | undefined;
    outTime?: Date | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    companyId?: number | undefined;
    isAdjusted?: boolean | undefined;
    pcnSubStatus?: number;
    pcnSubStatusText?: string | undefined;
    payReg?: number;
    isPositive?: boolean | undefined;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedBy?: string | undefined;
    updatedOn?: Date | undefined;
}

export class PayrollRecordUpdateExclusionRequest implements IPayrollRecordUpdateExclusionRequest {
    recordsToExclude?: ExcludedRecordEntry[] | undefined;
    recordsToReinclude?: number[] | undefined;

    constructor(data?: IPayrollRecordUpdateExclusionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recordsToExclude"])) {
                this.recordsToExclude = [] as any;
                for (let item of _data["recordsToExclude"])
                    this.recordsToExclude!.push(ExcludedRecordEntry.fromJS(item));
            }
            if (Array.isArray(_data["recordsToReinclude"])) {
                this.recordsToReinclude = [] as any;
                for (let item of _data["recordsToReinclude"])
                    this.recordsToReinclude!.push(item);
            }
        }
    }

    static fromJS(data: any): PayrollRecordUpdateExclusionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRecordUpdateExclusionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recordsToExclude)) {
            data["recordsToExclude"] = [];
            for (let item of this.recordsToExclude)
                data["recordsToExclude"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.recordsToReinclude)) {
            data["recordsToReinclude"] = [];
            for (let item of this.recordsToReinclude)
                data["recordsToReinclude"].push(item);
        }
        return data;
    }
}

export interface IPayrollRecordUpdateExclusionRequest {
    recordsToExclude?: ExcludedRecordEntry[] | undefined;
    recordsToReinclude?: number[] | undefined;
}

export class PayrollRulesDataRequest implements IPayrollRulesDataRequest {
    caregiverId?: string | undefined;
    employerIds?: string[] | undefined;
    serviceDate?: Date;

    constructor(data?: IPayrollRulesDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverId = _data["caregiverId"];
            if (Array.isArray(_data["employerIds"])) {
                this.employerIds = [] as any;
                for (let item of _data["employerIds"])
                    this.employerIds!.push(item);
            }
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollRulesDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRulesDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverId"] = this.caregiverId;
        if (Array.isArray(this.employerIds)) {
            data["employerIds"] = [];
            for (let item of this.employerIds)
                data["employerIds"].push(item);
        }
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPayrollRulesDataRequest {
    caregiverId?: string | undefined;
    employerIds?: string[] | undefined;
    serviceDate?: Date;
}

export class PayrollRulesDataResponse implements IPayrollRulesDataResponse {
    externalKeys?: string[] | undefined;

    constructor(data?: IPayrollRulesDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalKeys"])) {
                this.externalKeys = [] as any;
                for (let item of _data["externalKeys"])
                    this.externalKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): PayrollRulesDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRulesDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalKeys)) {
            data["externalKeys"] = [];
            for (let item of this.externalKeys)
                data["externalKeys"].push(item);
        }
        return data;
    }
}

export interface IPayrollRulesDataResponse {
    externalKeys?: string[] | undefined;
}

export class PayrollRun implements IPayrollRun {
    payrollRunId?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    blobFileUrl?: string | undefined;
    isProcessing?: boolean;

    constructor(data?: IPayrollRun) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollRunId = _data["payrollRunId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.blobFileUrl = _data["blobFileUrl"];
            this.isProcessing = _data["isProcessing"];
        }
    }

    static fromJS(data: any): PayrollRun {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollRunId"] = this.payrollRunId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["blobFileUrl"] = this.blobFileUrl;
        data["isProcessing"] = this.isProcessing;
        return data;
    }
}

export interface IPayrollRun {
    payrollRunId?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    blobFileUrl?: string | undefined;
    isProcessing?: boolean;
}

export class PayrollRunGridResponseBase implements IPayrollRunGridResponseBase {
    items?: PayrollRun[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollRun;

    constructor(data?: IPayrollRunGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayrollRun.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PayrollRun.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollRunGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRunGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayrollRunGridResponseBase {
    items?: PayrollRun[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollRun;
}

export enum PayrollRunStatus {
    InProgress = "InProgress",
    Submitted = "Submitted",
    Approved = "Approved",
    Rejected = "Rejected",
    Paid = "Paid",
    FileCreated = "FileCreated",
    Integrated = "Integrated",
}

export class PayrollRunStatusRequest implements IPayrollRunStatusRequest {
    payrollRunId?: string | undefined;
    status?: string | undefined;

    constructor(data?: IPayrollRunStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollRunId = _data["payrollRunId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PayrollRunStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRunStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollRunId"] = this.payrollRunId;
        data["status"] = this.status;
        return data;
    }
}

export interface IPayrollRunStatusRequest {
    payrollRunId?: string | undefined;
    status?: string | undefined;
}

export class PayrollRunStatusStatusHistory implements IPayrollRunStatusStatusHistory {
    status?: number;
    timeStamp?: Date;
    userDetails?: string | undefined;
    readonly statusText?: string | undefined;

    constructor(data?: IPayrollRunStatusStatusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.timeStamp = _data["timeStamp"] ? new Date(_data["timeStamp"].toString()) : <any>undefined;
            this.userDetails = _data["userDetails"];
            (<any>this).statusText = _data["statusText"];
        }
    }

    static fromJS(data: any): PayrollRunStatusStatusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRunStatusStatusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
        data["userDetails"] = this.userDetails;
        data["statusText"] = this.statusText;
        return data;
    }
}

export interface IPayrollRunStatusStatusHistory {
    status?: number;
    timeStamp?: Date;
    userDetails?: string | undefined;
    statusText?: string | undefined;
}

export class PayrollRunStatusStatusHistoryGridResponseBase implements IPayrollRunStatusStatusHistoryGridResponseBase {
    items?: PayrollRunStatusStatusHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollRunStatusStatusHistory;

    constructor(data?: IPayrollRunStatusStatusHistoryGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayrollRunStatusStatusHistory.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PayrollRunStatusStatusHistory.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollRunStatusStatusHistoryGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollRunStatusStatusHistoryGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayrollRunStatusStatusHistoryGridResponseBase {
    items?: PayrollRunStatusStatusHistory[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollRunStatusStatusHistory;
}

export class PayrollTransactionLogRequest implements IPayrollTransactionLogRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    docType?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    startFlsaDate?: Date | undefined;
    endFlsaDate?: Date | undefined;
    startPayPeriodDate?: Date | undefined;
    endPayPeriodDate?: Date | undefined;
    payrollExternalId?: string | undefined;
    isolationId?: string | undefined;
    userMail?: string | undefined;
    caregiverId?: number | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    companyId?: number | undefined;
    companyCode?: string | undefined;
    serviceCodes?: string[] | undefined;
    employeeIds?: string[] | undefined;

    constructor(data?: IPayrollTransactionLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            if (Array.isArray(_data["docType"])) {
                this.docType = [] as any;
                for (let item of _data["docType"])
                    this.docType!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.startFlsaDate = _data["startFlsaDate"] ? new Date(_data["startFlsaDate"].toString()) : <any>undefined;
            this.endFlsaDate = _data["endFlsaDate"] ? new Date(_data["endFlsaDate"].toString()) : <any>undefined;
            this.startPayPeriodDate = _data["startPayPeriodDate"] ? new Date(_data["startPayPeriodDate"].toString()) : <any>undefined;
            this.endPayPeriodDate = _data["endPayPeriodDate"] ? new Date(_data["endPayPeriodDate"].toString()) : <any>undefined;
            this.payrollExternalId = _data["payrollExternalId"];
            this.isolationId = _data["isolationId"];
            this.userMail = _data["userMail"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.employerId = _data["employerId"];
            this.companyId = _data["companyId"];
            this.companyCode = _data["companyCode"];
            if (Array.isArray(_data["serviceCodes"])) {
                this.serviceCodes = [] as any;
                for (let item of _data["serviceCodes"])
                    this.serviceCodes!.push(item);
            }
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PayrollTransactionLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollTransactionLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        if (Array.isArray(this.docType)) {
            data["docType"] = [];
            for (let item of this.docType)
                data["docType"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["startFlsaDate"] = this.startFlsaDate ? this.startFlsaDate.toISOString() : <any>undefined;
        data["endFlsaDate"] = this.endFlsaDate ? this.endFlsaDate.toISOString() : <any>undefined;
        data["startPayPeriodDate"] = this.startPayPeriodDate ? this.startPayPeriodDate.toISOString() : <any>undefined;
        data["endPayPeriodDate"] = this.endPayPeriodDate ? this.endPayPeriodDate.toISOString() : <any>undefined;
        data["payrollExternalId"] = this.payrollExternalId;
        data["isolationId"] = this.isolationId;
        data["userMail"] = this.userMail;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["employerId"] = this.employerId;
        data["companyId"] = this.companyId;
        data["companyCode"] = this.companyCode;
        if (Array.isArray(this.serviceCodes)) {
            data["serviceCodes"] = [];
            for (let item of this.serviceCodes)
                data["serviceCodes"].push(item);
        }
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        return data;
    }
}

export interface IPayrollTransactionLogRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    docType?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date | undefined;
    startFlsaDate?: Date | undefined;
    endFlsaDate?: Date | undefined;
    startPayPeriodDate?: Date | undefined;
    endPayPeriodDate?: Date | undefined;
    payrollExternalId?: string | undefined;
    isolationId?: string | undefined;
    userMail?: string | undefined;
    caregiverId?: number | undefined;
    participantId?: string | undefined;
    employerId?: string | undefined;
    companyId?: number | undefined;
    companyCode?: string | undefined;
    serviceCodes?: string[] | undefined;
    employeeIds?: string[] | undefined;
}

export class PayrollTransactionLogResponse implements IPayrollTransactionLogResponse {
    id?: number;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    participantId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    timeIn?: Date;
    timeOut?: Date;
    totalHours?: number | undefined;
    payUnits?: number | undefined;
    payStatus?: PcnStatus;
    readonly payStatusText?: string | undefined;
    payRate?: number | undefined;
    payDate?: Date | undefined;
    payTotal?: number | undefined;
    transactionId?: string | undefined;
    createdOn?: Date | undefined;
    user?: string | undefined;
    lastUpdate?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    payorCode?: string | undefined;
    isPositive?: boolean;
    exclusion?: boolean;
    exclusionReason?: string | undefined;
    docType?: string | undefined;
    employerId?: string | undefined;
    payrollExternalId?: string | undefined;
    isAdjusted?: boolean;
    isLocked?: boolean;
    isHoliday?: boolean;
    isFICA?: boolean;
    isFICAChild?: boolean;
    is20147?: boolean;
    isOvertimeEligible?: boolean;
    payCalcMethod?: string | undefined;
    isolationId?: string | undefined;
    payPeriodStart?: Date | undefined;
    payPeriodEnd?: Date | undefined;
    checkNbr?: string | undefined;

    constructor(data?: IPayrollTransactionLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.participantName = _data["participantName"];
            this.participantId = _data["participantId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverId = _data["caregiverId"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : <any>undefined;
            this.timeIn = _data["timeIn"] ? new Date(_data["timeIn"].toString()) : <any>undefined;
            this.timeOut = _data["timeOut"] ? new Date(_data["timeOut"].toString()) : <any>undefined;
            this.totalHours = _data["totalHours"];
            this.payUnits = _data["payUnits"];
            this.payStatus = _data["payStatus"];
            (<any>this).payStatusText = _data["payStatusText"];
            this.payRate = _data["payRate"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.payTotal = _data["payTotal"];
            this.transactionId = _data["transactionId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.payorCode = _data["payorCode"];
            this.isPositive = _data["isPositive"];
            this.exclusion = _data["exclusion"];
            this.exclusionReason = _data["exclusionReason"];
            this.docType = _data["docType"];
            this.employerId = _data["employerId"];
            this.payrollExternalId = _data["payrollExternalId"];
            this.isAdjusted = _data["isAdjusted"];
            this.isLocked = _data["isLocked"];
            this.isHoliday = _data["isHoliday"];
            this.isFICA = _data["isFICA"];
            this.isFICAChild = _data["isFICAChild"];
            this.is20147 = _data["is20147"];
            this.isOvertimeEligible = _data["isOvertimeEligible"];
            this.payCalcMethod = _data["payCalcMethod"];
            this.isolationId = _data["isolationId"];
            this.payPeriodStart = _data["payPeriodStart"] ? new Date(_data["payPeriodStart"].toString()) : <any>undefined;
            this.payPeriodEnd = _data["payPeriodEnd"] ? new Date(_data["payPeriodEnd"].toString()) : <any>undefined;
            this.checkNbr = _data["checkNbr"];
        }
    }

    static fromJS(data: any): PayrollTransactionLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollTransactionLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["participantName"] = this.participantName;
        data["participantId"] = this.participantId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["caregiverName"] = this.caregiverName;
        data["caregiverId"] = this.caregiverId;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : <any>undefined;
        data["timeIn"] = this.timeIn ? this.timeIn.toISOString() : <any>undefined;
        data["timeOut"] = this.timeOut ? this.timeOut.toISOString() : <any>undefined;
        data["totalHours"] = this.totalHours;
        data["payUnits"] = this.payUnits;
        data["payStatus"] = this.payStatus;
        data["payStatusText"] = this.payStatusText;
        data["payRate"] = this.payRate;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["payTotal"] = this.payTotal;
        data["transactionId"] = this.transactionId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["payorCode"] = this.payorCode;
        data["isPositive"] = this.isPositive;
        data["exclusion"] = this.exclusion;
        data["exclusionReason"] = this.exclusionReason;
        data["docType"] = this.docType;
        data["employerId"] = this.employerId;
        data["payrollExternalId"] = this.payrollExternalId;
        data["isAdjusted"] = this.isAdjusted;
        data["isLocked"] = this.isLocked;
        data["isHoliday"] = this.isHoliday;
        data["isFICA"] = this.isFICA;
        data["isFICAChild"] = this.isFICAChild;
        data["is20147"] = this.is20147;
        data["isOvertimeEligible"] = this.isOvertimeEligible;
        data["payCalcMethod"] = this.payCalcMethod;
        data["isolationId"] = this.isolationId;
        data["payPeriodStart"] = this.payPeriodStart ? this.payPeriodStart.toISOString() : <any>undefined;
        data["payPeriodEnd"] = this.payPeriodEnd ? this.payPeriodEnd.toISOString() : <any>undefined;
        data["checkNbr"] = this.checkNbr;
        return data;
    }
}

export interface IPayrollTransactionLogResponse {
    id?: number;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    participantName?: string | undefined;
    participantId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    caregiverName?: string | undefined;
    caregiverId?: string | undefined;
    servCode?: string | undefined;
    servDate?: Date;
    timeIn?: Date;
    timeOut?: Date;
    totalHours?: number | undefined;
    payUnits?: number | undefined;
    payStatus?: PcnStatus;
    payStatusText?: string | undefined;
    payRate?: number | undefined;
    payDate?: Date | undefined;
    payTotal?: number | undefined;
    transactionId?: string | undefined;
    createdOn?: Date | undefined;
    user?: string | undefined;
    lastUpdate?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    payorCode?: string | undefined;
    isPositive?: boolean;
    exclusion?: boolean;
    exclusionReason?: string | undefined;
    docType?: string | undefined;
    employerId?: string | undefined;
    payrollExternalId?: string | undefined;
    isAdjusted?: boolean;
    isLocked?: boolean;
    isHoliday?: boolean;
    isFICA?: boolean;
    isFICAChild?: boolean;
    is20147?: boolean;
    isOvertimeEligible?: boolean;
    payCalcMethod?: string | undefined;
    isolationId?: string | undefined;
    payPeriodStart?: Date | undefined;
    payPeriodEnd?: Date | undefined;
    checkNbr?: string | undefined;
}

export class PayrollTransactionLogResponseGridResponseBase implements IPayrollTransactionLogResponseGridResponseBase {
    items?: PayrollTransactionLogResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollTransactionLogResponse;

    constructor(data?: IPayrollTransactionLogResponseGridResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PayrollTransactionLogResponse.fromJS(item));
            }
            this.totalRecordCount = _data["totalRecordCount"];
            this.errorMessage = _data["errorMessage"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.data = _data["data"] ? PayrollTransactionLogResponse.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollTransactionLogResponseGridResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollTransactionLogResponseGridResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalRecordCount"] = this.totalRecordCount;
        data["errorMessage"] = this.errorMessage;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayrollTransactionLogResponseGridResponseBase {
    items?: PayrollTransactionLogResponse[] | undefined;
    totalRecordCount?: number;
    errorMessage?: string | undefined;
    pageNumber?: number;
    pageSize?: number;
    data?: PayrollTransactionLogResponse;
}

export class PayrollTransactionLogSummary implements IPayrollTransactionLogSummary {
    payUnitSummary?: number | undefined;
    payTotalSummary?: number | undefined;
    excludedRecordCount?: number | undefined;
    payrollTransactionLogResponse?: PayrollTransactionLogResponseGridResponseBase;

    constructor(data?: IPayrollTransactionLogSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payUnitSummary = _data["payUnitSummary"];
            this.payTotalSummary = _data["payTotalSummary"];
            this.excludedRecordCount = _data["excludedRecordCount"];
            this.payrollTransactionLogResponse = _data["payrollTransactionLogResponse"] ? PayrollTransactionLogResponseGridResponseBase.fromJS(_data["payrollTransactionLogResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayrollTransactionLogSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollTransactionLogSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payUnitSummary"] = this.payUnitSummary;
        data["payTotalSummary"] = this.payTotalSummary;
        data["excludedRecordCount"] = this.excludedRecordCount;
        data["payrollTransactionLogResponse"] = this.payrollTransactionLogResponse ? this.payrollTransactionLogResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPayrollTransactionLogSummary {
    payUnitSummary?: number | undefined;
    payTotalSummary?: number | undefined;
    excludedRecordCount?: number | undefined;
    payrollTransactionLogResponse?: PayrollTransactionLogResponseGridResponseBase;
}

export enum PcnStatus {
    New = "New",
    InProgress = "InProgress",
    ReadyToBePaid = "ReadyToBePaid",
    Paid = "Paid",
    Hold = "Hold",
    NeverToBePaid = "NeverToBePaid",
    Processed = "Processed",
}

export class PostRequestBase implements IPostRequestBase {
    id?: number;
    identifier?: string | undefined;

    constructor(data?: IPostRequestBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): PostRequestBase {
        data = typeof data === 'object' ? data : {};
        let result = new PostRequestBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IPostRequestBase {
    id?: number;
    identifier?: string | undefined;
}

export class PreviewPayrollBatchRequest implements IPreviewPayrollBatchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payrollSystem?: string | undefined;
    payors?: string[] | undefined;
    isEPR?: boolean;
    caregiverIds?: number[] | undefined;
    serviceCodes?: string[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date;
    estimatedPayDate?: Date;
    cutoffDate?: Date | undefined;
    isolationId?: string | undefined;
    isTimeWorked?: boolean;
    isAbsence?: boolean;
    excludedRecordIds?: number[] | undefined;
    excludeSelectedServiceCodes?: boolean;
    excludedRecords?: ExcludedRecordEntry[] | undefined;
    filterType?: string | undefined;
    isDisplayExcludedItemsOnly?: boolean;

    constructor(data?: IPreviewPayrollBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.payrollSystem = _data["payrollSystem"];
            if (Array.isArray(_data["payors"])) {
                this.payors = [] as any;
                for (let item of _data["payors"])
                    this.payors!.push(item);
            }
            this.isEPR = _data["isEPR"];
            if (Array.isArray(_data["caregiverIds"])) {
                this.caregiverIds = [] as any;
                for (let item of _data["caregiverIds"])
                    this.caregiverIds!.push(item);
            }
            if (Array.isArray(_data["serviceCodes"])) {
                this.serviceCodes = [] as any;
                for (let item of _data["serviceCodes"])
                    this.serviceCodes!.push(item);
            }
            this.startServiceDate = _data["startServiceDate"] ? new Date(_data["startServiceDate"].toString()) : <any>undefined;
            this.endServiceDate = _data["endServiceDate"] ? new Date(_data["endServiceDate"].toString()) : <any>undefined;
            this.estimatedPayDate = _data["estimatedPayDate"] ? new Date(_data["estimatedPayDate"].toString()) : <any>undefined;
            this.cutoffDate = _data["cutoffDate"] ? new Date(_data["cutoffDate"].toString()) : <any>undefined;
            this.isolationId = _data["isolationId"];
            this.isTimeWorked = _data["isTimeWorked"];
            this.isAbsence = _data["isAbsence"];
            if (Array.isArray(_data["excludedRecordIds"])) {
                this.excludedRecordIds = [] as any;
                for (let item of _data["excludedRecordIds"])
                    this.excludedRecordIds!.push(item);
            }
            this.excludeSelectedServiceCodes = _data["excludeSelectedServiceCodes"];
            if (Array.isArray(_data["excludedRecords"])) {
                this.excludedRecords = [] as any;
                for (let item of _data["excludedRecords"])
                    this.excludedRecords!.push(ExcludedRecordEntry.fromJS(item));
            }
            this.filterType = _data["filterType"];
            this.isDisplayExcludedItemsOnly = _data["isDisplayExcludedItemsOnly"];
        }
    }

    static fromJS(data: any): PreviewPayrollBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewPayrollBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["payrollSystem"] = this.payrollSystem;
        if (Array.isArray(this.payors)) {
            data["payors"] = [];
            for (let item of this.payors)
                data["payors"].push(item);
        }
        data["isEPR"] = this.isEPR;
        if (Array.isArray(this.caregiverIds)) {
            data["caregiverIds"] = [];
            for (let item of this.caregiverIds)
                data["caregiverIds"].push(item);
        }
        if (Array.isArray(this.serviceCodes)) {
            data["serviceCodes"] = [];
            for (let item of this.serviceCodes)
                data["serviceCodes"].push(item);
        }
        data["startServiceDate"] = this.startServiceDate ? this.startServiceDate.toISOString() : <any>undefined;
        data["endServiceDate"] = this.endServiceDate ? this.endServiceDate.toISOString() : <any>undefined;
        data["estimatedPayDate"] = this.estimatedPayDate ? this.estimatedPayDate.toISOString() : <any>undefined;
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : <any>undefined;
        data["isolationId"] = this.isolationId;
        data["isTimeWorked"] = this.isTimeWorked;
        data["isAbsence"] = this.isAbsence;
        if (Array.isArray(this.excludedRecordIds)) {
            data["excludedRecordIds"] = [];
            for (let item of this.excludedRecordIds)
                data["excludedRecordIds"].push(item);
        }
        data["excludeSelectedServiceCodes"] = this.excludeSelectedServiceCodes;
        if (Array.isArray(this.excludedRecords)) {
            data["excludedRecords"] = [];
            for (let item of this.excludedRecords)
                data["excludedRecords"].push(item ? item.toJSON() : <any>undefined);
        }
        data["filterType"] = this.filterType;
        data["isDisplayExcludedItemsOnly"] = this.isDisplayExcludedItemsOnly;
        return data;
    }
}

export interface IPreviewPayrollBatchRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    payrollSystem?: string | undefined;
    payors?: string[] | undefined;
    isEPR?: boolean;
    caregiverIds?: number[] | undefined;
    serviceCodes?: string[] | undefined;
    startServiceDate?: Date | undefined;
    endServiceDate?: Date;
    estimatedPayDate?: Date;
    cutoffDate?: Date | undefined;
    isolationId?: string | undefined;
    isTimeWorked?: boolean;
    isAbsence?: boolean;
    excludedRecordIds?: number[] | undefined;
    excludeSelectedServiceCodes?: boolean;
    excludedRecords?: ExcludedRecordEntry[] | undefined;
    filterType?: string | undefined;
    isDisplayExcludedItemsOnly?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export enum PropertyAttributes {
    None = "None",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
    HasDefault = "HasDefault",
    Reserved2 = "Reserved2",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export class PropertyInfo implements IPropertyInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    readonly isSpecialName?: boolean;
    readonly canRead?: boolean;
    readonly canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : <any>undefined;
            this.attributes = _data["attributes"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : <any>undefined;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    isSpecialName?: boolean;
    canRead?: boolean;
    canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;
}

export class QualificationTypeEntity implements IQualificationTypeEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    id?: number;
    qualification?: string | undefined;

    constructor(data?: IQualificationTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.qualification = _data["qualification"];
        }
    }

    static fromJS(data: any): QualificationTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["qualification"] = this.qualification;
        return data;
    }
}

export interface IQualificationTypeEntity {
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    createdOn?: Date | undefined;
    updatedOn?: Date | undefined;
    id?: number;
    qualification?: string | undefined;
}

export class RateHistoryBaseResponse implements IRateHistoryBaseResponse {
    caregiverEmployerMappingId?: number;
    payrollRecordId?: number;
    payRate?: number;
    baseRateAmount?: number;
    subPayRate?: number | undefined;
    isSubPayUnits?: boolean;
    serviceDate?: Date;
    careerHours?: number;
    rateComponents?: RateHistoryModComponent[] | undefined;

    constructor(data?: IRateHistoryBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caregiverEmployerMappingId = _data["caregiverEmployerMappingId"];
            this.payrollRecordId = _data["payrollRecordId"];
            this.payRate = _data["payRate"];
            this.baseRateAmount = _data["baseRateAmount"];
            this.subPayRate = _data["subPayRate"];
            this.isSubPayUnits = _data["isSubPayUnits"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.careerHours = _data["careerHours"];
            if (Array.isArray(_data["rateComponents"])) {
                this.rateComponents = [] as any;
                for (let item of _data["rateComponents"])
                    this.rateComponents!.push(RateHistoryModComponent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RateHistoryBaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RateHistoryBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caregiverEmployerMappingId"] = this.caregiverEmployerMappingId;
        data["payrollRecordId"] = this.payrollRecordId;
        data["payRate"] = this.payRate;
        data["baseRateAmount"] = this.baseRateAmount;
        data["subPayRate"] = this.subPayRate;
        data["isSubPayUnits"] = this.isSubPayUnits;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["careerHours"] = this.careerHours;
        if (Array.isArray(this.rateComponents)) {
            data["rateComponents"] = [];
            for (let item of this.rateComponents)
                data["rateComponents"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRateHistoryBaseResponse {
    caregiverEmployerMappingId?: number;
    payrollRecordId?: number;
    payRate?: number;
    baseRateAmount?: number;
    subPayRate?: number | undefined;
    isSubPayUnits?: boolean;
    serviceDate?: Date;
    careerHours?: number;
    rateComponents?: RateHistoryModComponent[] | undefined;
}

export class RateHistoryModComponent implements IRateHistoryModComponent {
    payrollRecordId?: number;
    minHours?: number;
    maxHours?: number;
    payRate?: number;
    subPayRate?: number | undefined;
    isSubPayUnits?: boolean;
    serviceDate?: Date;
    startDate?: Date;
    endDate?: Date;
    careerHours?: number;
    careerHourRateModifierId?: number;
    rateComponentAmount?: number;
    rateComponentType?: string | undefined;

    constructor(data?: IRateHistoryModComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollRecordId = _data["payrollRecordId"];
            this.minHours = _data["minHours"];
            this.maxHours = _data["maxHours"];
            this.payRate = _data["payRate"];
            this.subPayRate = _data["subPayRate"];
            this.isSubPayUnits = _data["isSubPayUnits"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.careerHours = _data["careerHours"];
            this.careerHourRateModifierId = _data["careerHourRateModifierId"];
            this.rateComponentAmount = _data["rateComponentAmount"];
            this.rateComponentType = _data["rateComponentType"];
        }
    }

    static fromJS(data: any): RateHistoryModComponent {
        data = typeof data === 'object' ? data : {};
        let result = new RateHistoryModComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollRecordId"] = this.payrollRecordId;
        data["minHours"] = this.minHours;
        data["maxHours"] = this.maxHours;
        data["payRate"] = this.payRate;
        data["subPayRate"] = this.subPayRate;
        data["isSubPayUnits"] = this.isSubPayUnits;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["careerHours"] = this.careerHours;
        data["careerHourRateModifierId"] = this.careerHourRateModifierId;
        data["rateComponentAmount"] = this.rateComponentAmount;
        data["rateComponentType"] = this.rateComponentType;
        return data;
    }
}

export interface IRateHistoryModComponent {
    payrollRecordId?: number;
    minHours?: number;
    maxHours?: number;
    payRate?: number;
    subPayRate?: number | undefined;
    isSubPayUnits?: boolean;
    serviceDate?: Date;
    startDate?: Date;
    endDate?: Date;
    careerHours?: number;
    careerHourRateModifierId?: number;
    rateComponentAmount?: number;
    rateComponentType?: string | undefined;
}

export class RateModifierQualification implements IRateModifierQualification {
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    careerHourRateModifierQualificationId?: number | undefined;
    isStackable?: boolean;
    rateModifier?: number;

    constructor(data?: IRateModifierQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modifierCreatedOn = _data["modifierCreatedOn"] ? new Date(_data["modifierCreatedOn"].toString()) : <any>undefined;
            this.modifierUpdatedOn = _data["modifierUpdatedOn"] ? new Date(_data["modifierUpdatedOn"].toString()) : <any>undefined;
            this.qualificationTypeId = _data["qualificationTypeId"];
            this.qualificationCreatedOn = _data["qualificationCreatedOn"] ? new Date(_data["qualificationCreatedOn"].toString()) : <any>undefined;
            this.qualificationUpdatedOn = _data["qualificationUpdatedOn"] ? new Date(_data["qualificationUpdatedOn"].toString()) : <any>undefined;
            this.careerHourRateModifierQualificationId = _data["careerHourRateModifierQualificationId"];
            this.isStackable = _data["isStackable"];
            this.rateModifier = _data["rateModifier"];
        }
    }

    static fromJS(data: any): RateModifierQualification {
        data = typeof data === 'object' ? data : {};
        let result = new RateModifierQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifierCreatedOn"] = this.modifierCreatedOn ? this.modifierCreatedOn.toISOString() : <any>undefined;
        data["modifierUpdatedOn"] = this.modifierUpdatedOn ? this.modifierUpdatedOn.toISOString() : <any>undefined;
        data["qualificationTypeId"] = this.qualificationTypeId;
        data["qualificationCreatedOn"] = this.qualificationCreatedOn ? this.qualificationCreatedOn.toISOString() : <any>undefined;
        data["qualificationUpdatedOn"] = this.qualificationUpdatedOn ? this.qualificationUpdatedOn.toISOString() : <any>undefined;
        data["careerHourRateModifierQualificationId"] = this.careerHourRateModifierQualificationId;
        data["isStackable"] = this.isStackable;
        data["rateModifier"] = this.rateModifier;
        return data;
    }
}

export interface IRateModifierQualification {
    modifierCreatedOn?: Date | undefined;
    modifierUpdatedOn?: Date | undefined;
    qualificationTypeId?: number | undefined;
    qualificationCreatedOn?: Date | undefined;
    qualificationUpdatedOn?: Date | undefined;
    careerHourRateModifierQualificationId?: number | undefined;
    isStackable?: boolean;
    rateModifier?: number;
}

export class Response implements IResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    id?: number;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface IResponse {
    isSuccess?: boolean;
    message?: string | undefined;
    id?: number;
}

export class ResponseModel implements IResponseModel {
    isSuccess?: boolean;
    id?: number;
    message?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponseModel {
    isSuccess?: boolean;
    id?: number;
    message?: string | undefined;
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value?: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value?: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeTypeHandle {
    value?: IntPtr;
}

export class SaveReviewBatchCommand implements ISaveReviewBatchCommand {
    accessRights?: string[] | undefined;
    payrollRunId?: string | undefined;
    batchDescription?: string | undefined;

    constructor(data?: ISaveReviewBatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(item);
            }
            this.payrollRunId = _data["payrollRunId"];
            this.batchDescription = _data["batchDescription"];
        }
    }

    static fromJS(data: any): SaveReviewBatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReviewBatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item);
        }
        data["payrollRunId"] = this.payrollRunId;
        data["batchDescription"] = this.batchDescription;
        return data;
    }
}

export interface ISaveReviewBatchCommand {
    accessRights?: string[] | undefined;
    payrollRunId?: string | undefined;
    batchDescription?: string | undefined;
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export class ServiceCode implements IServiceCode {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    servCode!: string;

    constructor(data?: IServiceCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayValue = _data["displayValue"];
            this.servCode = _data["servCode"];
        }
    }

    static fromJS(data: any): ServiceCode {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayValue"] = this.displayValue;
        data["servCode"] = this.servCode;
        return data;
    }
}

export interface IServiceCode {
    id?: number;
    description?: string | undefined;
    displayValue?: string | undefined;
    servCode: string;
}

export class StringComboboxModel implements IStringComboboxModel {
    id?: string | undefined;
    text?: string | undefined;

    constructor(data?: IStringComboboxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): StringComboboxModel {
        data = typeof data === 'object' ? data : {};
        let result = new StringComboboxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IStringComboboxModel {
    id?: string | undefined;
    text?: string | undefined;
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId?: any | undefined;
    value?: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }
}

export interface IStructLayoutAttribute {
    typeId?: any | undefined;
    value?: LayoutKind;
}

export enum TaskCreationOptions {
    None = "None",
    PreferFairness = "PreferFairness",
    LongRunning = "LongRunning",
    AttachedToParent = "AttachedToParent",
    DenyChildAttach = "DenyChildAttach",
    HideScheduler = "HideScheduler",
    RunContinuationsAsynchronously = "RunContinuationsAsynchronously",
}

export enum TaskStatus {
    Created = "Created",
    WaitingForActivation = "WaitingForActivation",
    WaitingToRun = "WaitingToRun",
    Running = "Running",
    WaitingForChildrenToComplete = "WaitingForChildrenToComplete",
    RanToCompletion = "RanToCompletion",
    Canceled = "Canceled",
    Faulted = "Faulted",
}

export class TcnCentralDBResponse implements ITcnCentralDBResponse {
    tcnId?: string | undefined;
    responseCode?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    payrollBatchApprovalDate?: Date | undefined;

    constructor(data?: ITcnCentralDBResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tcnId = _data["tcnId"];
            this.responseCode = _data["responseCode"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.payrollBatchApprovalDate = _data["payrollBatchApprovalDate"] ? new Date(_data["payrollBatchApprovalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TcnCentralDBResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TcnCentralDBResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcnId"] = this.tcnId;
        data["responseCode"] = this.responseCode;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["payrollBatchApprovalDate"] = this.payrollBatchApprovalDate ? this.payrollBatchApprovalDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITcnCentralDBResponse {
    tcnId?: string | undefined;
    responseCode?: number;
    checkNumber?: string | undefined;
    checkAmount?: number | undefined;
    paidDate?: Date | undefined;
    payrollBatchApprovalDate?: Date | undefined;
}

export enum TcnLockedBy {
    ShiftAdjustments = "ShiftAdjustments",
    CreateClaimBatch = "CreateClaimBatch",
    CreatePayrollBatch = "CreatePayrollBatch",
}

export class TransactionLogHistory implements ITransactionLogHistory {
    payrollRunId?: string | undefined;
    status?: string | undefined;
    createdOn?: Date;
    exclusionReason?: string | undefined;
    createdBy?: string | undefined;

    constructor(data?: ITransactionLogHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payrollRunId = _data["payrollRunId"];
            this.status = _data["status"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.exclusionReason = _data["exclusionReason"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): TransactionLogHistory {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionLogHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payrollRunId"] = this.payrollRunId;
        data["status"] = this.status;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["exclusionReason"] = this.exclusionReason;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ITransactionLogHistory {
    payrollRunId?: string | undefined;
    status?: string | undefined;
    createdOn?: Date;
    exclusionReason?: string | undefined;
    createdBy?: string | undefined;
}

export class TransactionLogHistoryRequest implements ITransactionLogHistoryRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    tcn?: string | undefined;

    constructor(data?: ITransactionLogHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
            this.filterColumn = _data["filterColumn"];
            this.filterValue = _data["filterValue"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.filterType = _data["filterType"];
            this.tcn = _data["tcn"];
        }
    }

    static fromJS(data: any): TransactionLogHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionLogHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        data["filterColumn"] = this.filterColumn;
        data["filterValue"] = this.filterValue;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["filterType"] = this.filterType;
        data["tcn"] = this.tcn;
        return data;
    }
}

export interface ITransactionLogHistoryRequest {
    sortColumn?: string | undefined;
    sortDirection?: string | undefined;
    filterColumn?: string | undefined;
    filterValue?: string | undefined;
    pageSize?: number;
    pageNumber?: number;
    filterType?: string | undefined;
    tcn?: string | undefined;
}

export class Type implements IType {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly isFunctionPointer?: boolean;
    readonly isUnmanagedFunctionPointer?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).isFunctionPointer = _data["isFunctionPointer"];
            (<any>this).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IType {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    isFunctionPointer?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
}

export enum TypeAttributes {
    NotPublic = "NotPublic",
    Public = "Public",
    NestedPublic = "NestedPublic",
    NestedPrivate = "NestedPrivate",
    NestedFamily = "NestedFamily",
    NestedAssembly = "NestedAssembly",
    NestedFamANDAssem = "NestedFamANDAssem",
    VisibilityMask = "VisibilityMask",
    SequentialLayout = "SequentialLayout",
    ExplicitLayout = "ExplicitLayout",
    LayoutMask = "LayoutMask",
    Interface = "Interface",
    Abstract = "Abstract",
    Sealed = "Sealed",
    SpecialName = "SpecialName",
    RTSpecialName = "RTSpecialName",
    Import = "Import",
    Serializable = "Serializable",
    WindowsRuntime = "WindowsRuntime",
    UnicodeClass = "UnicodeClass",
    AutoClass = "AutoClass",
    StringFormatMask = "StringFormatMask",
    HasSecurity = "HasSecurity",
    ReservedMask = "ReservedMask",
    BeforeFieldInit = "BeforeFieldInit",
    CustomFormatMask = "CustomFormatMask",
}

export class TypeInfo implements ITypeInfo {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly isFunctionPointer?: boolean;
    readonly isUnmanagedFunctionPointer?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;
    readonly genericTypeParameters?: Type[] | undefined;
    readonly declaredConstructors?: ConstructorInfo[] | undefined;
    readonly declaredEvents?: EventInfo[] | undefined;
    readonly declaredFields?: FieldInfo[] | undefined;
    readonly declaredMembers?: MemberInfo[] | undefined;
    readonly declaredMethods?: MethodInfo[] | undefined;
    readonly declaredNestedTypes?: TypeInfo[] | undefined;
    readonly declaredProperties?: PropertyInfo[] | undefined;
    readonly implementedInterfaces?: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
            (<any>this).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (<any>this).namespace = _data["namespace"];
            (<any>this).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (<any>this).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            (<any>this).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : <any>undefined;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : <any>undefined;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : <any>undefined;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : <any>undefined;
            (<any>this).isTypeDefinition = _data["isTypeDefinition"];
            (<any>this).isArray = _data["isArray"];
            (<any>this).isByRef = _data["isByRef"];
            (<any>this).isPointer = _data["isPointer"];
            (<any>this).isConstructedGenericType = _data["isConstructedGenericType"];
            (<any>this).isGenericParameter = _data["isGenericParameter"];
            (<any>this).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (<any>this).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (<any>this).isGenericType = _data["isGenericType"];
            (<any>this).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (<any>this).isSZArray = _data["isSZArray"];
            (<any>this).isVariableBoundArray = _data["isVariableBoundArray"];
            (<any>this).isByRefLike = _data["isByRefLike"];
            (<any>this).isFunctionPointer = _data["isFunctionPointer"];
            (<any>this).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (<any>this).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (<any>this).genericTypeArguments!.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isImport = _data["isImport"];
            (<any>this).isSealed = _data["isSealed"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isClass = _data["isClass"];
            (<any>this).isNestedAssembly = _data["isNestedAssembly"];
            (<any>this).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (<any>this).isNestedFamily = _data["isNestedFamily"];
            (<any>this).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (<any>this).isNestedPrivate = _data["isNestedPrivate"];
            (<any>this).isNestedPublic = _data["isNestedPublic"];
            (<any>this).isNotPublic = _data["isNotPublic"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isAutoLayout = _data["isAutoLayout"];
            (<any>this).isExplicitLayout = _data["isExplicitLayout"];
            (<any>this).isLayoutSequential = _data["isLayoutSequential"];
            (<any>this).isAnsiClass = _data["isAnsiClass"];
            (<any>this).isAutoClass = _data["isAutoClass"];
            (<any>this).isUnicodeClass = _data["isUnicodeClass"];
            (<any>this).isCOMObject = _data["isCOMObject"];
            (<any>this).isContextful = _data["isContextful"];
            (<any>this).isEnum = _data["isEnum"];
            (<any>this).isMarshalByRef = _data["isMarshalByRef"];
            (<any>this).isPrimitive = _data["isPrimitive"];
            (<any>this).isValueType = _data["isValueType"];
            (<any>this).isSignatureType = _data["isSignatureType"];
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : <any>undefined;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : <any>undefined;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : <any>undefined;
            (<any>this).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : <any>undefined;
            (<any>this).isSerializable = _data["isSerializable"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (<any>this).genericTypeParameters!.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (<any>this).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (<any>this).declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (<any>this).declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (<any>this).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (<any>this).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (<any>this).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (<any>this).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (<any>this).implementedInterfaces!.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item ? item.toJSON() : <any>undefined);
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITypeInfo {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    isFunctionPointer?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
    genericTypeParameters?: Type[] | undefined;
    declaredConstructors?: ConstructorInfo[] | undefined;
    declaredEvents?: EventInfo[] | undefined;
    declaredFields?: FieldInfo[] | undefined;
    declaredMembers?: MemberInfo[] | undefined;
    declaredMethods?: MethodInfo[] | undefined;
    declaredNestedTypes?: TypeInfo[] | undefined;
    declaredProperties?: PropertyInfo[] | undefined;
    implementedInterfaces?: Type[] | undefined;
}

export class UpdateTcnStatusRequest implements IUpdateTcnStatusRequest {
    tcnDetails?: TcnCentralDBResponse[] | undefined;

    constructor(data?: IUpdateTcnStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tcnDetails"])) {
                this.tcnDetails = [] as any;
                for (let item of _data["tcnDetails"])
                    this.tcnDetails!.push(TcnCentralDBResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTcnStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTcnStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tcnDetails)) {
            data["tcnDetails"] = [];
            for (let item of this.tcnDetails)
                data["tcnDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateTcnStatusRequest {
    tcnDetails?: TcnCentralDBResponse[] | undefined;
}

export class UpsertPayrollConfigurationRequest implements IUpsertPayrollConfigurationRequest {
    servCodeEarnTypeId?: number;
    serviceCode?: string | undefined;
    earningType?: string | undefined;
    oldEarningType?: string | undefined;
    isAbsence?: boolean;
    exclusionCriteria?: ExclusionCriterionEntry[] | undefined;

    constructor(data?: IUpsertPayrollConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servCodeEarnTypeId = _data["servCodeEarnTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.earningType = _data["earningType"];
            this.oldEarningType = _data["oldEarningType"];
            this.isAbsence = _data["isAbsence"];
            if (Array.isArray(_data["exclusionCriteria"])) {
                this.exclusionCriteria = [] as any;
                for (let item of _data["exclusionCriteria"])
                    this.exclusionCriteria!.push(ExclusionCriterionEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertPayrollConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPayrollConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servCodeEarnTypeId"] = this.servCodeEarnTypeId;
        data["serviceCode"] = this.serviceCode;
        data["earningType"] = this.earningType;
        data["oldEarningType"] = this.oldEarningType;
        data["isAbsence"] = this.isAbsence;
        if (Array.isArray(this.exclusionCriteria)) {
            data["exclusionCriteria"] = [];
            for (let item of this.exclusionCriteria)
                data["exclusionCriteria"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpsertPayrollConfigurationRequest {
    servCodeEarnTypeId?: number;
    serviceCode?: string | undefined;
    earningType?: string | undefined;
    oldEarningType?: string | undefined;
    isAbsence?: boolean;
    exclusionCriteria?: ExclusionCriterionEntry[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
